{
  "translation": {
    "ai_templates": {
      "menu_title_pet": "Pet Portraits",
      "menu_title_family": "Family Portraits",
      "menu_title_kids": "Kids Wall Art",
      "menu_title_places": "Places Art",
      "menu_title_travel_posters": "Travel Posters",
      "menu_title_vintage_posters": "Vintage Posters",
      "menu_title_home_hobbies": "Home & Hobbies",
      "menu_title_kitchen_art": "Kitchen Art",
      "menu_title_food_drink_art": "Food & Drink Art",
      "menu_title_food_recipe_art": "Food & Recipe Art",
      "menu_title_travel": "Travel",
      "variants": {
        "boy": "Boy",
        "girl": "Girl"
      },
      "faces_selection": {
        "title": "Select Faces",
        "subtitle": "Make sure faces are clear and show the eyes and hair",
        "no_faces_detected": "No faces were detected",
        "generate_button": "Generate Photos ({{count}} {{label}})",
        "person": "Person",
        "people": "People",
        "pet": "Pet",
        "pets": "Pets",
        "portraits": "Portraits"
      },
      "multi_upload": {
        "title": "For the best results",
        "cta": "Upload 1-9 Photos"
      },
      "kids_wall": {
        "child_name": "Child's name",
        "interests_label": "Name 2-3 things they love",
        "interests_placeholder": "e.g., dinosaurs, football, unicorns",
        "interests_hint": "Avoid trademarked characters"
      },
      "upload_menu": {
        "create": "Create",
        "text_input_title": "Pet's name (optional)",
        "processing": "Processing...",
        "upload_photo": "Upload Photo",
        "cta": {
          "upload_pet_photo": "Upload Pet Photo",
          "upload_couple_photo": "Upload Couple Photo",
          "upload_old_photo": "Upload Old Photo",
          "upload_photo_with_faces": "Upload Photo with Faces",
          "upload_scenic_photo": "Upload Scenic Photo",
          "upload_family_photo": "Upload Family Photo"
        }
      },
      "results": {
        "add_tile": "Add Tile",
        "next": "Next"
      },
      "loading": {
        "creating_photos": "Creating Photos..."
      },
      "variations": {
        "generation_failed": "Couldn't create your new style. Please try again.",
        "create_button_one": "Create {{count}} portrait",
        "create_button_other": "Create {{count}} portraits",
        "add_portraits_line_1": "Add portraits",
        "add_portraits_line_2": "for",
        "add_portraits_for_pet": "Add portraits for your pet",
        "change_pet_photo": "Change pet photo",
        "back_to_add_options": "Back to add options",
        "load_failed": "Couldn't load styles. Please try again.",
        "no_more_templates": "no more templates for your pet",
        "generating_snackbar": "Creating"
      },
      "errors": {
        "unexpected_error": "Image generation failed",
        "safety_reject": "Image rejected for safety reasons",
        "service_unavailable": "Generation failed: Service unavailable",
        "image_too_large": "Generation failed: Image too large",
        "image_processing_failed": "Generation failed: Could not process image",
        "rate_limit": "You have reached the limit of requests for today. Please try again tomorrow."
      }
    },
    "art": {
      "home": {
        "cta_browse": "Browse Art",
        "subtitle": "Easily frame & hang the art you love",
        "title": "Decorate Your Walls in Minutes",
        "title_with_category": "The {{v1}} Collection"
      },
      "collection": {
        "categories": {
          "Best Sellers": "Best Sellers",
          "Animals": "Animals",
          "Sayings": "Sayings",
          "Plants": "Plants",
          "Beach": "Beach",
          "Abstract": "Abstract",
          "Lines": "Lines",
          "Famous Artists": "Famous Artists",
          "Geometric": "Geometric",
          "Flowers": "Flowers",
          "Classic Art": "Classic Art",
          "Kitchen": "Kitchen",
          "Kids": "Kids",
          "Botanical": "Botanical",
          "Destinations": "Destinations",
          "Urban": "Urban",
          "Mountains": "Mountains",
          "Faith": "Faith",
          "Nature": "Nature",
          "Travel": "Travel",
          "Dogs & Cats": "Dogs & Cats"
        }
      },
      "select_art": "Select Art"
    },
    "business": {
      "add_emails": "Add emails",
      "company_name": "Company name",
      "contact_form_title": "Fill out this form and one of our experts will get in touch soon",
      "csv": "Upload CSV",
      "desired_amount_of_tiles": "Desired amount of tiles",
      "employees_gift_cards": "Employees Gift Cards",
      "employees_to_be_gifted": "Employees to be gifted",
      "gift_card_for_title": "Digital Gift Cards, Bulk Discount",
      "submit": {
        "subtitle": "One of our experts will be in touch shortly",
        "title": "Thank you! Your request has been received"
      },
      "subtitle": "Experience the ease and beauty of custom photo tiles. Our special B2B packages offers special discounts and experts support.",
      "title": "For All Your Business Needs",
      "your_name": "Your name"
    },
    "centerpiece": {
      "add_wall_sign": "Add Wall Sign",
      "bottom_text": "BOTTOM TEXT",
      "customize": "Customize",
      "top_text": "TOP TEXT"
    },
    "download_app": {
      "card": {
        "title": "Your gallery wall is ready for you!",
        "subtitle": "Our smart app creates stunning gallery walls from your very best photos"
      },
      "hero": {
        "title": "Your photo books are ready for you!",
        "subtitle": "Our smart app creates stunning photo books from your very best photos"
      },
      "cta": "Download the App"
    },
    "collage": {
      "add_more": "Add more photos to create a collage",
      "collage": "Collage",
      "edit_collage": "Edit",
      "exceeding_photos": {
        "choose_photos_plural": "Choose {{v1}} photos for this layout",
        "choose_photos_singular": "Choose 1 photo for this layout",
        "select_more_photos_plural": "Select {{v1}} More Photos",
        "select_more_photos_singular": "Select 1 More Photo"
      },
      "layout_rearrange_notice": "This will rearrange the layout",
      "text_limit_reached": "You've hit the text limit",
      "text_unsupported_size": "Change size to add text"
    },
    "designer": {
      "add_tile_or_collage_to_enable_bulk_editing": "Add Tile or Collage to Enable Bulk Edit",
      "add_tile_to_enable_bulk_editing": "Add tiles to enable bulk edit",
      "adjust_crop_description": "Pinch to zoom, drag to move",
      "adjust_crop_description_desktop": "Scroll to zoom, drag to move",
      "adjust_crop_hint": "Pinch or drag to adjust crop",
      "adjust_crop_hint_desktop": "Drag to adjust crop",
      "bad_crop": {
        "approve_btn": "Approve & Place Order",
        "back_btn": "Back",
        "desktop_subtitle": "Scroll to zoom, drag to move",
        "edit": "Edit Entire Order",
        "mobile_subtitle": "Pinch to zoom, drag to move",
        "next_btn": "Next",
        "review_btn": "Review Photos",
        "title": "Let's ensure your photos are cropped to your satisfaction!"
      },
      "border": "border",
      "bulk_override_warning": {
        "apply_filter": "Apply Filter",
        "apply_frame_color": "Apply Frame",
        "apply_mat": "Apply Mat",
        "apply_material": "Apply Material",
        "apply_size": "Apply Size",
        "apply_to_all": "Apply to All",
        "title": "Apply this {{style}} to all tiles?"
      },
      "change_mat": "Try a different mat to view colors",
      "choose_swap": "Choose a photo to swap with",
      "color": "color",
      "crop": "Crop",
      "delete": "Delete",
      "duplicate": "Clone",
      "drop_files": "Drop photos to upload",
      "effect": "effect",
      "excellent_quality": {
        "cta": "Got It",
        "subtitle": "We'll notify you if there's any issue",
        "title": "Excellent photo quality!"
      },
      "change_mat_notifications": {
        "partial_apply": {
          "title": "Borders applied partially",
          "single_material_subtitle": "{{v1}} does not support borders",
          "generic_material_subtitle": "Some tiles do not support borders"
        },
        "disabled": "Available in other frame types"
      },
      "frameless_8x8_caption": "{{v1}} only",
      "filter": "filter",
      "wide": "Wide",
      "frame": "frame",
      "layout": "layout",
      "mat": "mat",
      "material": "material",
      "matting": "matting",
      "mixed_sizes": "Mixed Sizes",
      "out_of_stock_warning": {
        "approve": "Change to {{size}}",
        "cancel": "Stay with {{material}}",
        "product_approve": "Change to {{product}}",
        "product_cancel": "Stay with {{product}}",
        "product_title": "{{product}} are out of stock",
        "title": "{{size}} {{material}} tiles are out of stock",
        "out_of_stock": "Out of Stock"
      },
      "photos": "Photos",
      "progress_bar": {
        "adding_photos": "Adding photos...",
        "framing_your_photos": "Framing your photos..."
      },
      "recommended_size": "Recommended {{v1}} or smaller",
      "select_border": "Select Border",
      "select_color": "Select Color",
      "select_effect": "Select Effect",
      "select_filter": "Select Filter",
      "select_frame": "Select Frame",
      "select_frame_color": "Select Frame Color",
      "select_layout": "Select Layout",
      "select_mat": "Select Mat Effect",
      "select_material": "Select Material",
      "select_matting": "Select Matting",
      "select_size": "Select Size",
      "select_style": "Select Style",
      "select_text_style": "Select Text Style",
      "handwriting": "Handwriting",
      "classic": "Classic",
      "bold": "BOLD",
      "size": "size",
      "swap_positions": "Swap Positions",
      "text": "text",
      "tile_deleted": "Tile deleted"
    },
    "general": {
      "address_form": {
        "add_title": "Add Address",
        "change_save": "Update",
        "change_title": "Change Address",
        "form_fields": {
          "address": "Address",
          "address_2": "Address 2",
          "city": "City",
          "country": "country",
          "full_name": "Full Name",
          "full_name_kana": "Name Reading",
          "full_name_kana_placeholder": "Enter the katakana reading of the name",
          "phone": "Phone Number",
          "postal": "Postal Code",
          "province": "Province",
          "state": "State",
          "state_or_province": "State / Province",
          "state_or_territory": "State / Territory",
          "zip": "Zip Code"
        },
        "phone_number_info": "The phone number will be used in case we need to contact you for delivery",
        "suggest_offers": "Sign me up for text and messaging-app updates on exclusive offers",
        "suggest_offers_email": "Sign me up for email updates on exclusive offers",
        "re_enter_address": "Re-enter Address",
        "use_this_address_anyway": "Use This Address Anyway",
        "validation_errors": {
          "address": {
            "invalid": "Invalid city/state/post code",
            "not_found": "Invalid address",
            "not_supported": "Sorry, {{product}} orders aren't available in your country"
          },
          "city_state": {
            "invalid": "Invalid city or state"
          },
          "country": {
            "unsupported": "Sorry, we don't ship to your country yet"
          },
          "email": {
            "invalid": "Please enter a valid email address"
          },
          "full_name": {
            "invalid": "Please insert your full name (first and last name) "
          },
          "full_name_kana": {
            "missing": "Please enter the kana reading of your name",
            "invalid": "The name reading must be hiragana or katakana only"
          },
          "non_latin_characters": "Please use Latin characters only",
          "house_number": {
            "invalid": "Invalid street number",
            "missing": "Street number missing"
          },
          "missing_fields": {
            "general": "Please fill all required fields to continue",
            "specific": "Please fill your {{v1}} to continue"
          },
          "name": {
            "invalid": "Please enter your name",
            "too_long": "Name cannot exceed {{v1}} characters"
          },
          "phone": {
            "invalid": "Please enter a valid phone number"
          },
          "secondary_information": {
            "invalid": "Invalid apt/suite number",
            "missing": "Apt/suite number missing"
          },
          "state": {
            "invalid": "Invalid state"
          },
          "street": {
            "invalid": "Invalid street name",
            "missing": "Street name missing",
            "po_box": "Can't ship to po box addresses"
          },
          "mind_another_look": "Mind giving it another look?",
          "zip": {
            "invalid": "Invalid post code",
            "not_found": "Invalid post code",
            "state_mismatch": "Zip code and state doesn't match",
            "unsupported_territory": "Can't ship to this region"
          }
        }
      },
      "applied": "applied",
      "auto_save_message": "We auto-save your work",
      "best_seller": "Best Seller",
      "add": "Add",
      "cancel": "Cancel",
      "discard_changes": "Discard Changes",
      "done": "Done",
      "each": "each",
      "errors": {
        "dark_mode_subTitle": "Switch to light mode via system settings for true color display",
        "dark_mode_title": "Dark Mode Displays Frame Colors Incorrectly",
        "general_description": "Sorry for that! Please try again and let us know if the issue persists.",
        "general_description_short": "Please try again",
        "general_title": "Oops! Something went wrong",
        "general_title_short": "Something went wrong",
        "order_cancelled_title": "Order Cancelled",
        "order_cancelled_refund_subtitle": "Refund is being processed",
        "webgl_not_supported_subtitle": "Try opening this page in Safari or Chrome to view this preview.",
        "webgl_not_supported_title": "This preview can't be displayed on this browser"
      },
      "from_price": "From {{v1}}",
      "gdpr_dialog": {
        "privacy_policy": "Privacy Policy",
        "terms_of_use": "Terms of Use"
      },
      "got_it": "Got It",
      "languages": {
        "change_language": "Change Language",
        "de": "Deutsch",
        "en": "English",
        "es": "Español",
        "fr": "Français",
        "ja": "日本語",
        "language": "Language"
      },
      "learn_more": "Learn More",
      "menu": {
        "accessibility_button": "Accessibility",
        "add_promo_code": {
          "modal": {
            "form_title": "Your Code",
            "placeholder": "Enter Here",
            "title": "Add Promo Code",
            "title_with_gift_card": "Add Promo Code or Gift Card"
          },
          "success": {
            "code_applied": "{{v1}} Applied"
          }
        },
        "art_collection": "Art Collection",
        "buy_gift_card": "Buy Gift Card",
        "chat_with_us": "Chat with Us",
        "faq": "FAQs",
        "for_business": "For Business",
        "frame_your_photos": "Frame Your Photos",
        "gift_card": "Gift Card",
        "gift_card_v2": "Gift Card",
        "help_center": "Help Center",
        "my_orders": "My Orders",
        "privacy_policy": "Privacy Policy",
        "cookie_policy": "Cookie Policy",
        "promo_code_manager": {
          "promo_codes": "Promo Codes"
        },
        "use_code_to_save": "Code '{{v1}}' applied, save up to {{v2}}%. Discount varies by size & material"
      },
      "new": "New",
      "ok": "Ok",
      "optional": "Optional",
      "payment_form": {
        "header": "Billing Address",
        "same_shipping_address": "Billing and shipping addresses are the same",
        "validation_errors": {
          "address": {
            "missing": "Please fill address details to continue"
          },
          "missing_fields": {
            "general": "Please fill payment details to continue"
          }
        }
      },
      "promo_code_selector": {
        "default": "default",
        "disclaimer": "Discount varies by size & material",
        "free_tile_description": "{{v1}} free {{v2}} tiles",
        "free_book_description": "{{v1}} free {{v2}} books",
        "free_tiles": "Free Tiles",
        "free_books": "Free Books",
        "gift_card_description": "{{v1}} credit ({{v2}} available)",
        "promo_not_applied_to_product": "This promo doesn't apply to {{v1}}",
        "select_volume_discount": "Select Discount",
        "volume_discount_applied": "Volume Discount Applied"
      },
      "promo_code_success_dialog": {
        "call_to_action": "Shop Now!",
        "save_message_on_product": "Save {{v1}} on {{v2}}",
        "save_up_to_message_shortened": "Save up to {{v1}}%",
        "size_and_material_disclaimer": "Save up to {{v1}}%. Discount varies by size & material",
        "subtitle": {
          "gift_card": "You've successfully added {{v1}}",
          "gift_card_tiles_many": "{{v1}} free tiles",
          "gift_card_tiles_one": "one free tile",
          "gift_card_books_many": "{{v1}} free photo books",
          "gift_card_books_one": "one free photo book"
        },
        "title": {
          "bundle": "{{v1}}{{size_constraint}} Tiles for {{v2}}",
          "free_tiles_many": "You got {{v1}} free tiles{{size_constraint}}!",
          "gift_card": "Gift Card Applied!"
        }
      },
      "refresh": "Refresh",
      "skip": "Skip",
      "start_creating": "Start Creating",
      "continue_design": "Continue Design",
      "talk_to_us": "Talk to Us",
      "try_again": "Try Again",
      "credits": {
        "balance": "You have {{v1}} in credits"
      }
    },
    "google_photos": {
      "authorize_title": "Connect to Google Photos",
      "authorize": "Sign In",
      "select_title": "Open Google Photos in a New Tab to Select Photos",
      "select_photos": "Open in a new tab",
      "error_title": "Error",
      "error_message": "Something went wrong. Please try again.",
      "try_again": "Try Again",
      "fetching_title": "Fetching chosen photos",
      "step_1": "Step 1",
      "step_2": "Step 2",
      "adding_photos": "Adding photos",
      "google_photos_requires_safari": "Google Photos requires opening Safari",
      "open_safari": "Open in Safari",
      "stay_here": "Stay Here",
      "disconnect": "Disconnect from Google Photos"
    },
    "get_started": {
      "form_fields": {
        "email": "Email"
      },
      "title": "Let's get to know you"
    },
    "gift_card": {
      "books": "Books",
      "buy_now": "Buy Now",
      "delivered_by_email_with_expiry": "Delivered by email, this gift card never expires",
      "form": {
        "add_email_address": "Add Email Address",
        "card_value_label": "Choose a card value",
        "choose_book_size": "Choose book size",
        "custom_placeholder": "Custom",
        "design_label": "Choose a design",
        "gift_message_label": "Gift message (optional)",
        "gift_message_placeholder": "Add a personal note",
        "gift_scheduler_label": "When should we send the gift card?",
        "now": "Now",
        "recipient_email_placeholder": "Recipient's email",
        "recipient_label": "Who's the lucky recipient?",
        "sender_label": "Who is it from?",
        "sender_name_placeholder": "Sender's name",
        "today": "Today"
      },
      "number_of_books": "{{v1}} books, {{v2}}",
      "number_of_tiles": "{{v1}} Tiles",
      "prepay_save_up_to": "Prepay and save up to {{v1}}%",
      "prepay_save_exact": "Prepay and save {{v1}}%",
      "sizes_note_2": "Only available for {{v1}} frame or frameless.",
      "switch_gift_card_type_cta": "Switch",
      "switch_to_tile_based_description": "to our other gift card - choose by number of tiles or books you want to give",
      "switch_to_value_based_description": "to our regular gift card, where you choose the value you want to gift. Supports all sizes and materials.",
      "tiles": "Tiles",
      "title_digital": "Digital Gift Card",
      "your_email": "Your Email"
    },
    "holidays": {
      "arrives_before_christmas": "Arrives before Christmas 🎄",
      "arrives_before_fathers_day": "Arrives before Father's Day",
      "arrives_before_mothers_day": "Arrives before Mother's Day",
      "arrives_before_valentines_day": "Arrives before Valentine's Day",
      "arrives_before_veterans_day": "Arrives before Veterans Day",
      "get_it_by_christmas": "Get it by Christmas 🎄",
      "get_it_by_fathers_day": "Get it by Father's Day",
      "get_it_by_mothers_day": "Get it by Mother's Day",
      "get_it_by_valentines_day": "Get it by Valentine's Day",
      "get_it_by_veterans_day": "Get it by Veterans Day"
    },
    "homepage": {
      "photo_books_banner": {
        "subtitle": "As seen on TV,\nOrder now",
        "cta": "Try Now"
      },
      "beauty": {
        "subtitle": "Every book comes with a hard, matte cover and is printed on premium pages with a silk finish",
        "title": "Beauty in Every Page",
        "design_subtitle": "A uniquely designed hardcover for every trip, crafted with premium print and silk-finish pages for a timeless collection",
        "design_title": "Designed to Be Collected",
        "life_events_subtitle": "A beautifully crafted hardcover, with premium print and silk-finish pages to build a collection you'll cherish forever",
        "life_events_title": "Designed to Be Collected"
      },
      "chat": {
        "content": "Talk with our real support team, Every day 7am to midnight EST",
        "cta": "Chat With Us",
        "title": "Need Help?"
      },
      "community": {
        "subtitle_black_frames": "Black {{v1}} frames",
        "subtitle_white_frames": "White {{v1}} frames",
        "subtitle_wood_frames": "Wood {{v1}} frames",
        "subtitle_wood_mixed_frames": "Wood mixed sizes frames",
        "title": "From Our Community"
      },
      "cookies_choices": "Your Privacy Choices",
      "covered": {
        "rated": "Rated {{v1}}",
        "rated_subtitle": "{{v1}}+ App Store ratings",
        "reviews": "reviews",
        "shipping": "Fast & Free Shipping",
        "shipping_subtitle": "*Free shipping over {{v1}}",
        "shipping_free_subtitle": "No minimum required",
        "support": "Dedicated Customer Support",
        "support_short": "Dedicated Support",
        "support_subtitle": "Real people ready to assist",
        "title": "We've Got You Covered",
        "trustpilot": "Rated Excellent on Trustpilot"
      },
      "faq": {
        "frames": {
          "content": "Sizes range from {{v1}} to {{v2}}, plus a unique {{v3}} option. Available in various materials and frame colors, including frameless and canvas options",
          "title": "How big are the tiles?"
        },
        "frames-art": {
          "content": "Sizes range from {{v1}} to {{v2}}. Available in various materials and frame colors, including frameless and canvas options",
          "title": "How big are the tiles?"
        },
        "move-tiles": {
          "content": "Super easy! They're designed to be repositioned multiple times without any damage",
          "title": "Is it easy to move the tiles around?"
        },
        "photo-books-customize": {
          "content": "Effortlessly! Our signature layout — featuring one photo per page — guarantees that every cherished memory receives its rightful spotlight. Personalize your Photo Book by handpicking the perfect photo for the front cover and truly make your book your own by customizing (or removing!) the text on the front. With just a click and drag, you can center your photos on each page or rearrange their order to tell your tale exactly as you envision it.",
          "title": "How can I customize my Photo Book?"
        },
        "photo-books-delivery": {
          "content": "You can expect your Photo Book to arrive approximately {{delivery_time}} business days after placing your order, but don't worry – you'll always see your estimated delivery date on the Checkout page before finalizing your order! Orders are delivered via UPS, and the best part? Shipping is absolutely free!",
          "title": "How long does it take to receive my Photo Book?"
        },
        "photo-books-discount": {
          "content": "Excellent question! Since Photo Books are a brand new addition to our lineup, most of our Mixtiles discounts won't apply just yet. However, if you have any Mixtiles Credits or a Value Gift Card, you can absolutely use them towards your Photo Book purchase!",
          "title": "I received a discount for Mixtiles. Can I apply it to my Photo Book purchase?"
        },
        "photo-books-material": {
          "content": "Photo Books are exclusively available in hardcover, promising durability with every page turn. The cover has a thin matte film, while each page inside features velvety, silk-feel, wood-free paper, enriching colors and reducing reflections. Last but certainly not least, Photo Books are also recyclable!",
          "title": "What materials are the books made of?"
        },
        "photo-books-shipment": {
          "content": "We currently deliver to the US, Canada, UK, EU, and Australia - we hope to expand to more countries in the near future!",
          "title": "What countries do you ship to?"
        },
        "photo-books-size": {
          "content": "Photo Books are available in three convenient sizes: {{v1}} for {{v1_price}}, {{v2}} for {{v2_price}}, and {{v3}} for {{v3_price}}. Regardless of the number of photos you decide to include in your book, the price will remain the same! Each Photo Book requires a minimum of 25 photos and up to a maximum of {{max_photos}} snapshots of your most treasured memories",
          "title": "What sizes do Photo Books come in?"
        },
        "photo-books-size-tiers": {
          "content": "Photo Books are available in three convenient sizes: {{v1}} from {{v1_price}}, {{v2}} from {{v2_price}}, and {{v3}} from {{v3_price}}. Each size has three simple price tiers based on page count: up to 40 pages, up to 120 pages, and up to 200 pages. Every Photo Book requires a minimum of 25 photos and can include up to {{max_photos}} of your most treasured memories.",
          "title": "What sizes do Photo Books come in?"
        },
        "photo-books-wedding-size": {
          "content": "Mixtiles' wedding photo book comes in the following sizes: {{v1}}, {{v2}}, and {{v3}} so you can decide on the perfect one to keep precious photographic memories of your special day.",
          "title": "What size should I choose for my wedding photo book?"
        },
        "photo-books-wedding-paper": {
          "content": "At Mixtiles, we want to make sure that your wedding album photo book lasts eternally, which is why our books showcase a velvety, silk-feel paper and a matte-finished hardcover to ensure both durability and a professional touch.",
          "title": "What type of paper is best for creating a wedding album photo book?"
        },
        "photo-books-wedding-pages": {
          "content": "The number of pages in our wedding photobook typically depends on the number of photos you want to include and how detailed you want your book to be. A good starting point is around 20-40 pages, which allows for a comprehensive yet concise collection of your wedding memories.",
          "title": "How many pages should a wedding photobook have?"
        },
        "photo-books-wedding-durability": {
          "content": "A wedding album printing, when made with high-quality materials and stored properly, can last for many years, preserving your memories for future generations. It's important to keep the book away from direct sunlight and moisture to ensure its longevity.",
          "title": "How long will a wedding album printing last?"
        },
        "photo-books-wedding-vs-traditional": {
          "content": "Creating a wedding photo book offers a modern and streamlined way to display your wedding memories. With a unique one-tap creation process, it allows for automatic organization of photos into pages, ready to order immediately. You can further customize the arrangement if desired, making it a convenient and personalized alternative to traditional photo albums.",
          "title": "Why should I create wedding photo books instead of traditional photo albums?"
        },
        "photo-books-memory-what-is": {
          "content": "A photo memory book is a beautifully bound collection of photographs that captures and preserves your cherished memories. It's used to compile and showcase moments from various occasions, such as family gatherings, vacations, or significant life events. With Mixtiles, you can create a personalized photo memory book that tells your unique story, allowing you to relive your favorite moments with each page turn.",
          "title": "What is a photo memory book and what is it used for?"
        },
        "photo-books-memory-create": {
          "content": "Creating a photo memory book with Mixtiles is simple and intuitive. Start by uploading a minimum of 24 photos, selecting up to {{max_photos}} images to feature in your book. Use our easy editing tools to arrange, crop, and zoom your photos to your liking. Each book is designed with one photo per page, ensuring each memory shines. You can order your photo memory book via our website or app for a seamless experience.",
          "title": "How do I create a photo memory book?"
        },
        "photo-books-memory-occasions": {
          "content": "Photo memory books are perfect for a wide range of occasions. They make excellent keepsakes for weddings, birthdays, anniversaries, graduations, and holidays. Additionally, they serve as thoughtful memorial photo books, preserving the legacy of loved ones. Whether celebrating joyous events or commemorating someone special, a photo memory book is a timeless way to capture those moments.",
          "title": "What kind of occasions are photo memory books good for?"
        },
        "photo-books-memory-custom": {
          "content": "Creating a custom photo memory book allows you to personalize your collection of memories. With Mixtiles, you have the creative freedom to arrange your photos in the perfect order, ensuring your story is told just the way you want. Our premium quality books, printed on velvety, silk-feel paper with a sleek matte-finished hardcover, provide durability and elegance, making them lasting keepsakes.",
          "title": "Why should I create a custom photo memory book?"
        },
        "photo-books-memory-pages": {
          "content": "Mixtiles photo memory books can include up to {{max_photos}} pages, with each page featuring a single photo. This allows you to highlight each memory individually, giving every photo the attention it deserves. Whether you choose to include just a few pages or fill the book to its maximum capacity, your memories will be beautifully displayed.",
          "title": "How many pages can I include in a photo memory book?"
        },
        "photo-books-memory-cover": {
          "content": "Our photo memory books come with a sleek, matte-finished hardcover, offering both durability and a touch of elegance. You can choose a special photo for the front cover and customize the text to add a personal touch. The back cover remains photo-free, ensuring a clean and sophisticated look.",
          "title": "What cover options are available for photo memory books?"
        },
        "photo-books-memory-cost": {
          "content": "The cost of a photo memory book from Mixtiles varies based on the size and number of pages you choose. For precise pricing details, we recommend visiting our website or app. There, you can explore different options and find the best fit for your needs.",
          "title": "How much does a photo memory book cost?"
        },
        "photo-books-memory-easiest": {
          "content": "The easiest way to create a photo memory book is through Mixtiles' user-friendly digital platform. Our website and app provide intuitive tools for uploading, arranging, and editing your photos. With just a few clicks, you can design a stunning photo memory book that captures your most treasured memories. For assistance, our customer support is always ready to help via live chat or email.",
          "title": "What is the easiest way to create a photo memory book?"
        },
        "photo-books-small-sizes": {
          "content": "We offer three convenient sizes for our photo books: {{v1}} ({{v1_dimensions}}), {{v2}} ({{v2_dimensions}}), and {{v3}} ({{v3_dimensions}}). The {{v1}} size is perfect for a small photo book, offering a compact yet elegant way to showcase your cherished moments.",
          "title": "What sizes do small photo books come in?"
        },
        "photo-books-small-why-choose": {
          "content": "A small photo book is ideal for those who prefer a more portable and space-efficient option. It's perfect for personal keepsakes or gifts, allowing you to carry your memories with ease. The smaller size doesn't compromise on quality, as we ensure each book is crafted with premium materials and vibrant colors.",
          "title": "Why choose a small photo book instead of a larger one?"
        },
        "photo-books-small-occasions": {
          "content": "Small photo books are versatile and can beautifully capture a variety of themes, such as family gatherings, vacations, or special milestones. They are also great for creating themed collections, like a series of favorite pet photos or a child's first year, making them a perfect choice for personal storytelling.",
          "title": "What occasions or subjects work well for small photo books?"
        },
        "photo-books-small-pages": {
          "content": "Mixtiles' small photo books can hold between 24 to {{max_photos}} pages, with one photo per page layout. This allows you to create a comprehensive yet concise collection of your favorite images, ensuring each memory gets the spotlight it deserves.",
          "title": "How many pages can a small photo book hold?"
        },
        "photo-books-small-customizable": {
          "content": "Absolutely! Mixtiles offers extensive customization options for your small photo book. You can arrange, zoom, and crop your photos to fit your narrative perfectly. Additionally, you can personalize the cover by choosing a special photo and adding custom text to make it truly unique.",
          "title": "Are small photo books customizable?"
        },
        "photo-books-small-gifts": {
          "content": "Yes, small photo books make excellent gifts. Their compact size is perfect for sharing cherished memories with loved ones. Whether for a birthday, anniversary, or holiday, a personalized small photo book from Mixtiles is a thoughtful and meaningful present.",
          "title": "Are small photo books good as gifts?"
        },
        "photo-books-small-materials": {
          "content": "Mixtiles' small photo books are crafted with high-quality materials. The pages are made from velvety, silk-feel, wood-free paper that minimizes reflections and enhances color vibrancy. The hardcover is finished with a sleek matte film, ensuring durability and elegance.",
          "title": "What materials and finishes do small photo books use?"
        },
        "photo-books-small-story": {
          "content": "To create a meaningful story with your small photo book, start by selecting photos that align with your chosen theme or narrative. Arrange them in a sequence that reflects the progression of your story. Utilize Mixtiles' easy editing tools to crop and adjust your images, ensuring each page contributes to the overall storytelling experience. Personalize the cover with a title that encapsulates the essence of your collection, making it a memorable keepsake.",
          "title": "How can I make a small photo book tell a meaningful story?"
        },
        "photo-books-boudoir-what-is": {
          "content": "A boudoir photo book is a personalized collection of intimate and artistic photographs, often used to celebrate personal beauty and confidence. Creating a boudoir photo book allows you to capture special moments and emotions, making it a cherished keepsake. At Mixtiles, we ensure your boudoir photo book is beautifully bound and printed on premium quality paper, allowing you to relive these moments with every page turn.",
          "title": "What is a boudoir photo book and why create one?"
        },
        "photo-books-boudoir-select-photos": {
          "content": "Selecting photos for your boudoir photo book is a personal process. Start by choosing images that reflect your personality and the story you want to tell. Consider a mix of poses and expressions to add variety. At Mixtiles, our easy editing tools allow you to zoom, crop, and rearrange your photos to achieve the perfect look for your boudoir book printing.",
          "title": "How do I select which boudoir photos to include in the book?"
        },
        "photo-books-boudoir-layout": {
          "content": "When laying out photos in your boudoir photo book, aim for a balance between visual appeal and storytelling. At Mixtiles, we offer a user-friendly platform where each page features one photo, ensuring each memory gets the spotlight. You can customize the order to create a narrative flow that resonates with you.",
          "title": "How should I lay out the photos in a boudoir photo book?"
        },
        "photo-books-boudoir-size-style": {
          "content": "We offer three convenient sizes for our photo books: {{v1}}, {{v2}}, and {{v3}}. Choose a size that best suits your preference and the number of photos you wish to include. The sleek, matte-finished hardcover adds a touch of elegance, making it a perfect choice for a boudoir photo book.",
          "title": "What size and style should I choose for a boudoir photo book?"
        },
        "photo-books-boudoir-personalize": {
          "content": "Personalizing your boudoir photo book is simple with Mixtiles. You can add a special photo to the front cover and customize the text to summarize your story. This personal touch enhances the uniqueness of your boudoir book, making it a true reflection of your personality.",
          "title": "How can I personalize my boudoir photo book?"
        },
        "photo-books-boudoir-cover-materials": {
          "content": "While Mixtiles currently offers a sleek, matte-finished hardcover, many boudoir books traditionally use materials like leather or velvet for an added luxurious feel. Our hardcover is designed for durability and elegance, ensuring your boudoir photo book remains a timeless treasure.",
          "title": "What cover materials work well for boudoir books?"
        },
        "photo-books-boudoir-color-mix": {
          "content": "Including a mix of color and black-and-white images can add depth and contrast to your boudoir photo book. Black-and-white photos often highlight emotions and details, while color images bring vibrancy. At Mixtiles, our premium printing ensures both color and monochrome images appear rich and vivid.",
          "title": "Should I include a mix of color and black-and-white images?"
        },
        "photo-books-boudoir-order": {
          "content": "You can easily order your boudoir photo book through Mixtiles' website or app. Our one-tap creation process makes it simple to upload and organize your photos. Whether you're a first-time creator or an experienced designer, our platform supports your vision for the perfect boudoir book printing. If you need assistance, our team is always ready to help via email or live chat.",
          "title": "Where can I order a boudoir photo book?"
        },
        "photo-books-travel-why-make": {
          "content": "Creating a travel photo book is a wonderful way to preserve and relive your adventures. At Mixtiles, we offer personalized travel photo books that allow you to capture the essence of your journeys. Unlike digital albums, a tangible book provides a more intimate experience, letting you flip through pages filled with your favorite travel memories. Whether it's a solo trip or a family vacation, a Mixtiles travel photo book serves as a cherished keepsake that tells your unique story.",
          "title": "Why should I make a travel photo book?"
        },
        "photo-books-travel-features": {
          "content": "Our travel photo books offer various customization options to enhance your storytelling. You can include maps and itineraries to provide context to your adventures. Highlight specific locations with captions or add personal notes to each page. With Mixtiles, you have the creative freedom to arrange photos and text in a way that best represents your journey. Our intuitive platform makes it easy to personalize every aspect of your travel photo book.",
          "title": "What features can I add to a travel photo book?"
        },
        "photo-books-travel-cropping": {
          "content": "At Mixtiles, we prioritize ease of use and customization. Our platform allows you to crop and rearrange photos effortlessly. Each travel photo book features a single layout with one photo per page, ensuring every memory gets the attention it deserves. This design choice not only highlights each image but also maintains a clean and elegant look throughout your travel photo album.",
          "title": "How do travel photo books handle cropping and layouts?"
        },
        "photo-books-travel-details": {
          "content": "You can include a variety of travel details in your Mixtiles photo book to enrich your narrative. Add captions to describe the moments captured, include dates and locations, or even insert snippets of your travel itinerary. These elements help create a comprehensive travel photo album that not only showcases your photos but also tells the story behind each one.",
          "title": "What travel details can I include in my photo book?"
        },
        "photo-books-travel-structure": {
          "content": "Structuring your Mixtiles travel photo book to tell a story is straightforward. Start with a captivating cover photo and an introductory page that sets the scene for your journey. Organize your photos chronologically or by theme, such as landscapes, cultural experiences, or culinary adventures. Use captions and short narratives to guide the reader through your travels, creating a cohesive and engaging vacation photo book.",
          "title": "How can I structure a travel photo book to tell a story?"
        },
        "photo-books-travel-quality": {
          "content": "Yes, Mixtiles travel photo books are crafted with premium materials to ensure durability and quality. Printed on velvety, silk-feel paper, our books minimize reflections and enhance color vibrancy. The matte-finished hardcover adds elegance and protects your book, making it a long-lasting keepsake. Additionally, our eco-friendly materials mean your travel photo book is both beautiful and sustainable.",
          "title": "Are travel photo books high quality and durable?"
        },
        "photo-books-travel-services": {
          "content": "Mixtiles offers a user-friendly platform with a one-tap creation process. Once you upload your photos, our system organizes them into a ready-to-order book, which you can further customize. We provide three convenient sizes to suit your preferences, allowing you to create a travel photo book that perfectly fits your needs. Whether you prefer a compact or larger format, our templates accommodate your storytelling style.",
          "title": "What types of travel photo book services or templates are there?"
        },
        "photo-books-travel-relive": {
          "content": "A Mixtiles travel photo book is more than just a collection of images; it's a gateway to reliving your adventures. Each page turn brings back the emotions and experiences of your travels. Sharing your vacation photo book with friends and family allows you to recount your stories and inspire others. With Mixtiles, your travel memories are preserved in a beautiful, tangible form, ready to be revisited whenever you desire.",
          "title": "How can a travel photo book help me relive my adventures?"
        },
        "photo-books-coffee-table-what-is": {
          "content": "A coffee table photo book is a beautifully crafted book designed to showcase your favorite photos in a way that invites guests to browse and enjoy. At Mixtiles, we offer custom coffee table books that transform your cherished memories into stunning visual stories. These books are not only a conversation starter but also a personalized keepsake that adds a touch of elegance to any living space.",
          "title": "What is a coffee table photo book and why make one?"
        },
        "photo-books-coffee-table-themes": {
          "content": "Themes such as family gatherings, travel adventures, wedding celebrations, or even a year-in-review make for captivating coffee table photo books. With Mixtiles, you can easily create a custom coffee table book that reflects your unique experiences, thanks to our user-friendly platform that allows you to organize and customize your photos effortlessly.",
          "title": "What themes or subjects work well for a coffee table photo book?"
        },
        "photo-books-coffee-table-design": {
          "content": "Designing an engaging coffee table photo book is simple with Mixtiles. Our platform lets you upload and arrange your photos with ease. Each book features a single layout with one photo per page, ensuring every image gets the attention it deserves. You can zoom, crop, and rearrange your photos to create a seamless narrative that captivates viewers.",
          "title": "How do I design an engaging coffee table photo book (layout and content)?"
        },
        "photo-books-coffee-table-travel-wedding": {
          "content": "Absolutely! Travel and wedding photos are perfect for coffee table books. They capture significant moments that are both visually stunning and emotionally resonant. At Mixtiles, our premium quality photo books, with their silk-feel pages and matte-finished hardcovers, ensure that these important memories are preserved in the highest quality.",
          "title": "Should I include travel or wedding photos in a coffee table book?"
        },
        "photo-books-coffee-table-gifts": {
          "content": "Yes, coffee table photo books make excellent gifts. They are personal, thoughtful, and timeless. Whether you're celebrating a birthday, anniversary, or any other milestone, a custom coffee table book from Mixtiles can be a heartfelt gift that your loved ones will cherish for years to come.",
          "title": "Are coffee table photo books good as gifts?"
        },
        "photo-books-coffee-table-year-review": {
          "content": "A year-in-review coffee table book is a compilation of photos that highlight the most memorable moments of the past year. It's a wonderful way to reflect on achievements, celebrations, and everyday joys. With Mixtiles, creating a year-in-review book is straightforward, allowing you to showcase up to {{max_photos}} of your favorite memories in one elegant volume.",
          "title": "What is a year-in-review coffee table book?"
        },
        "photo-books-coffee-table-guest-house": {
          "content": "Coffee table photo books are perfect for guest houses or waiting rooms as they provide a welcoming atmosphere and engage visitors. They can showcase local attractions, historical highlights, or simply offer a visual journey through beautiful photography.",
          "title": "How can coffee table photo books be used in a guest house or waiting room?"
        },
        "photo-books-coffee-table-suitable": {
          "content": "A photo book suitable for a coffee table is one that is visually appealing, durable, and meaningful. At Mixtiles, we ensure our photo books meet these criteria with premium materials, a sleek design, and the ability to personalize each book to tell your story. Whether it's the rich color of the photos or the elegant matte-finished cover, our books are crafted to be a centerpiece in any room.",
          "title": "What makes a photo book suitable for display on a coffee table?"
        },
        "photo-books-engagement-what-is": {
          "content": "An engagement photo book is a beautifully bound collection of photos capturing the special moments leading up to your wedding. Creating one allows you to preserve memories from your engagement period in a tangible, elegant format. At Mixtiles, we offer engagement photo books that are printed on velvety, silk-feel paper, ensuring vibrant colors and a sleek matte-finished hardcover for durability. This makes them not only a stunning keepsake but also a unique way to share your love story with friends and family.",
          "title": "What is an engagement photo book and why create one?"
        },
        "photo-books-engagement-photos-include": {
          "content": "When curating your engagement photo book, consider including a variety of photos that capture the essence of your relationship. This might include candid shots, professional engagement photos, and any special moments shared during your engagement period. Our easy editing tools at Mixtiles allow you to zoom, crop, and rearrange your photos, ensuring each page reflects your story perfectly.",
          "title": "What photos should I include in an engagement photo book?"
        },
        "photo-books-engagement-proposal": {
          "content": "Absolutely! Including your proposal photos in your engagement photo book is a wonderful way to commemorate the moment you said \"yes.\" These photos set the stage for the story your engagement photo album tells, capturing the raw emotion and joy of that pivotal day. With Mixtiles, you can easily highlight these significant moments in your book.",
          "title": "Should I include my proposal photos in the engagement book?"
        },
        "photo-books-engagement-party": {
          "content": "Engagement party photos are a great addition to your engagement photo book. They capture the celebration of your commitment with loved ones and add a layer of joy and festivity to your album. With Mixtiles, you can include up to {{max_photos}} photos, so there's plenty of room to showcase these cherished memories.",
          "title": "What about engagement party photos – should they go in the book?"
        },
        "photo-books-engagement-vs-wedding": {
          "content": "Engagement photo books focus on the journey leading up to the wedding, capturing the proposal, engagement celebrations, and everyday moments of love. In contrast, wedding photo books typically document the wedding day itself. Our engagement photo books allow you to tell the story from \"Yes\" to wedding day, setting the stage for the next chapter of your life together.",
          "title": "How do engagement photo books differ from wedding photo books?"
        },
        "photo-books-engagement-cover-styles": {
          "content": "At Mixtiles, we offer a sleek, matte-finished hardcover for our engagement photo books, providing both elegance and durability. You can choose a special photo for the front cover and personalize the spine with text that summarizes your story, ensuring your book is as unique as your relationship.",
          "title": "What cover styles and materials can I choose for an engagement book?"
        },
        "photo-books-engagement-story": {
          "content": "An engagement photo book can chronicle your journey from the proposal to the wedding day through a curated selection of photos. By organizing your images in a way that reflects the progression of your relationship, you create a narrative that captures the anticipation and excitement leading up to your big day. Mixtiles' user-friendly platform allows you to arrange your photos seamlessly, helping you craft a compelling story.",
          "title": "How can an engagement book tell the story from \"Yes\" to wedding?"
        },
        "photo-books-engagement-keepsake": {
          "content": "Yes, an engagement photo book can serve as a beautiful keepsake or even a guest book at your wedding. Guests can flip through the pages and relive your journey, adding personal notes and well-wishes. Mixtiles' premium quality ensures that your engagement photo album will be a lasting memento of your special day, cherished for years to come.",
          "title": "Is an engagement photo book a good keepsake or guest book at the wedding?"
        },
        "photo-books-family-why-create": {
          "content": "Creating a family photo book allows you to preserve cherished memories in a tangible form. At Mixtiles, we make it easy to compile your favorite family moments into a beautifully bound book. Our photo books offer a personalized keepsake that you can flip through, reliving each special memory. Whether it's for a family yearbook or a special gift, our photo books help you celebrate your family's unique story.",
          "title": "Why should I create a family photo book?"
        },
        "photo-books-family-formats": {
          "content": "Our photo books are ideal for family photos due to their premium quality and customization options. We offer three convenient sizes: {{v1}}, {{v2}}, and {{v3}}, allowing you to choose the perfect format for your family photo book. Each book features a single layout with one photo per page, ensuring that every memory gets the spotlight it deserves.",
          "title": "What types of photo book formats are best for family photos?"
        },
        "photo-books-family-organize": {
          "content": "Organizing a family photo book with Mixtiles is simple and intuitive. Our platform allows you to upload and arrange your photos in the perfect order to tell your family's story. You can crop and zoom images to fit just right, creating a cohesive narrative throughout your book. Our one-tap creation process helps you get started quickly, while offering the flexibility to customize further.",
          "title": "How do I organize a family photo book?"
        },
        "photo-books-family-memories": {
          "content": "Include a mix of everyday moments and special occasions in your family photo book. Think about vacations, holidays, birthdays, and even candid snapshots that capture your family's essence. These memories will make your family yearbook a comprehensive reflection of your shared experiences.",
          "title": "What kind of family memories should I include?"
        },
        "photo-books-family-pages": {
          "content": "Our photo books can showcase between 24 to {{max_photos}} photos, with each image getting its own page. This range allows you to create a concise family yearbook or an extensive collection of memories, depending on your preference.",
          "title": "How many pages can a family photo book have?"
        },
        "photo-books-family-cover-size": {
          "content": "Mixtiles' photo books come with a sleek, matte-finished hardcover that adds durability and elegance. You can choose from three sizes: {{v1}}, {{v2}}, or {{v3}}, ensuring your family photo book fits your style and needs.",
          "title": "What cover and size options are available for family photo books?"
        },
        "photo-books-family-durable": {
          "content": "Our photo books are crafted with velvety, silk-feel paper and a matte film cover that enhances durability. This ensures your family photo book remains a cherished keepsake for years to come. Plus, all our photo books are eco-friendly and recyclable.",
          "title": "How can I make a family photo book durable and lasting?"
        },
        "photo-books-family-story": {
          "content": "To weave your family's story into the photo book, consider adding captions or anecdotes alongside your photos. With Mixtiles, you can customize the cover with a special photo and personalized text to summarize your story. This personal touch transforms your photo book into a narrative that highlights your family's history and milestones.",
          "title": "How do I incorporate my family's story or history into the photo book?"
        },
        "photo-books-yearly-what-is": {
          "content": "A yearly photo book is a wonderful way to recap the year's memories, capturing the essence of your experiences and milestones. At Mixtiles, we offer a seamless way to compile these cherished moments into a beautifully bound book, allowing you to reflect on and share your year-in-review with loved ones.",
          "title": "What is a yearly (annual) photo book used for?"
        },
        "photo-books-yearly-gather-photos": {
          "content": "To create a comprehensive year-in-review photo book, start by organizing your photos by month or significant events. This method makes it easy to select images that best represent each part of your year. Our platform allows you to upload and arrange these photos effortlessly, ensuring your album tells a cohesive story.",
          "title": "How do I gather photos for a year-in-review album?"
        },
        "photo-books-yearly-what-include": {
          "content": "Include your favorite experiences and connections from the past year. Whether it's family gatherings, vacations, or personal achievements, our photo books give each memory the spotlight it deserves. With Mixtiles' easy editing tools, you can zoom, crop, and rearrange photos to perfectly fit your narrative.",
          "title": "What should I include in a yearly photo book?"
        },
        "photo-books-yearly-themes-layouts": {
          "content": "A chronological timeline is an effective theme for a yearly photo book. It allows you to showcase the progression of your year, highlighting key moments in sequence. Our photo books feature a single photo per page layout, which ensures clarity and focus on each memory.",
          "title": "What themes or layouts work for a yearbook?"
        },
        "photo-books-yearly-formats": {
          "content": "We offer three convenient sizes for our photo books: {{v1}}, {{v2}}, and {{v3}}. Each size is designed to suit different preferences, from sleek and subtle to big and bold. At Mixtiles, we ensure your yearly photo book is crafted with premium materials, including a matte-finished hardcover and silk-feel pages.",
          "title": "What formats are available for annual photo books?"
        },
        "photo-books-yearly-personalize-cover": {
          "content": "Personalizing your photo book cover is simple with Mixtiles. Choose a special photo for the front cover and add a custom foil title to summarize your story. This personal touch makes your year-in-review photo book truly unique and reflective of your experiences.",
          "title": "How can I personalize the cover of a yearly photo book?"
        },
        "photo-books-yearly-why-make": {
          "content": "Creating a year-in-review photo book transforms your annual highlights into a time capsule of memories. It's a tangible way to preserve the moments that matter most, allowing you to relive them anytime. Our photo books are designed to last, making them a durable keepsake for years to come.",
          "title": "Why make a year-in-review photo book?"
        },
        "photo-books-yearly-how-often": {
          "content": "We recommend creating a yearly photo book every year to capture and preserve your annual highlights. This tradition allows you to build a collection of memories that you can look back on with fondness. With Mixtiles, the process is easy and enjoyable, ensuring each book is as special as the memories it holds.",
          "title": "How often should I make an annual photo book?"
        },
        "photo-books-valentines-great-gift": {
          "content": "A photo book makes a perfect Valentine's Day gift because it captures your love story in a tangible form. At Mixtiles, we offer beautifully bound photo books that allow you to flip through pages of cherished memories, making it a heartfelt keepsake. Our premium quality books, printed on velvety, silk-feel paper, ensure that your photos come to life with vibrant colors, creating a lasting impression of your love.",
          "title": "Why is a photo book a great Valentine's Day gift?"
        },
        "photo-books-valentines-unique-ideas": {
          "content": "One unique idea is to create a \"Reasons I Love You\" themed photo book. Compile photos that capture special moments and pair them with captions or love notes that express why you cherish your partner. This personalized touch transforms a simple photo collection into a meaningful narrative, showcasing the depth of your relationship.",
          "title": "What unique ideas can I use for a Valentine's photo book?"
        },
        "photo-books-valentines-style": {
          "content": "For a timeless look, consider styling your Valentine's photo book in all black-and-white photos. This classic approach adds elegance and sophistication, allowing the emotions in each image to stand out. With Mixtiles, you can easily edit your photos to achieve this effect, ensuring your book is both stylish and personal.",
          "title": "How can I style my Valentine's book?"
        },
        "photo-books-valentines-wedding-photos": {
          "content": "Absolutely! Including wedding photos in your Valentine's Day photo book is a wonderful way to relive one of the most romantic moments of your life. Our photo books feature one photo per page, giving each memory the spotlight it deserves. This makes it perfect for showcasing the highlights of your wedding day alongside other cherished memories.",
          "title": "Can I include wedding photos in a Valentine's photo book?"
        },
        "photo-books-valentines-focus": {
          "content": "Focus on capturing romantic moments and memories that define your relationship. Whether it's your first date, a memorable vacation, or everyday candid moments, these images tell the story of your love. Our easy editing tools allow you to organize and customize your photos, ensuring your Valentine's Day photo book reflects your unique journey together.",
          "title": "What should I focus on in a Valentine's book?"
        },
        "photo-books-valentines-fun-personal": {
          "content": "Mix candid and posed shots to create a fun and personal photo book. Candid photos capture genuine emotions and spontaneous moments, while posed shots can highlight special occasions. At Mixtiles, our one-tap creation process makes it easy to organize your photos, allowing you to add personal touches that make your book truly one-of-a-kind.",
          "title": "How do I make the book fun and personal?"
        },
        "photo-books-valentines-suitable-couples": {
          "content": "Yes, a Valentine's photo book is suitable for any couple, whether you are newlyweds or have been together for years. It's a versatile gift that celebrates your journey together, capturing both new and cherished memories. Our photo books offer a sleek, durable design that appeals to couples at any stage of their relationship.",
          "title": "Is a Valentine's photo book suitable for any couple?"
        },
        "photo-books-valentines-gather-content": {
          "content": "Gather content by collecting love notes, favorite photos, and meaningful quotes that encapsulate your relationship. Create an album on your device to save these selections, ensuring they're ready when you create your photo book. We recommend uploading a minimum of 24 photos to create a comprehensive and heartfelt Valentine's Day photo book.",
          "title": "How do I gather content for a Valentine's Day album?"
        },
        "photo-books-graduation-why-create": {
          "content": "Creating a graduation photo book is a wonderful way to preserve milestone memories of an important chapter in life. At Mixtiles, we offer beautifully bound photo books that allow you to curate and relive these cherished moments. Our photo books serve as personalized keepsakes that capture the joy and accomplishments of graduation day, providing a tangible reminder of your achievements.",
          "title": "Why should I create a graduation photo book?"
        },
        "photo-books-graduation-what-photos": {
          "content": "A well-rounded graduation photo book should include a variety of photos: the excitement of the first day, the pride of the graduation ceremony, candid moments with friends, and memorable events throughout the school year. These images collectively tell the story of your journey, highlighting personal growth and achievements along the way.",
          "title": "What photos should I include in a graduation album?"
        },
        "photo-books-graduation-organize": {
          "content": "You can organize your graduation photos either chronologically or by theme. At Mixtiles, we make it easy for you to arrange your photos exactly how you want them. Whether you choose to showcase the journey from start to finish or group photos by events or friendships, our easy editing tools allow you to customize your photo book to reflect your unique story.",
          "title": "How should I organize the photos?"
        },
        "photo-books-graduation-how-many-photos": {
          "content": "For a Mixtiles graduation photo book, you need a minimum of 24 photos and can include up to {{max_photos}}. Gather these images from your devices, social media, or friends who captured special moments. This collection will ensure a comprehensive and vibrant depiction of your graduation experience.",
          "title": "How many photos do I need, and where do I find them?"
        },
        "photo-books-graduation-design-theme": {
          "content": "Selecting a design theme for your graduation photo book depends on your personal style and the story you wish to tell. Our photo books come with a sleek, matte-finished hardcover and are printed on velvety, silk-feel paper, enhancing both the look and feel of your memories. Whether you prefer a classic, elegant design or something more modern and colorful, we ensure your photos come to life with rich color and premium quality.",
          "title": "What design theme should I choose for my graduation book?"
        },
        "photo-books-graduation-quotes-messages": {
          "content": "Yes, you can personalize your graduation photo book by including quotes or messages that resonate with your journey. While we don't offer a dedicated feature for generating QR codes, you can create one externally and upload it as an image. This way, you can add interactive elements to your photo book, enhancing its personal value.",
          "title": "Can I include things like quotes, messages, or QR codes?"
        },
        "photo-books-graduation-sort-upload": {
          "content": "Sorting and uploading your graduation photos with Mixtiles is a breeze. Our one-tap creation process organizes your photos into pages, making the book ready to order. You can further customize and arrange your photos to ensure each page reflects your personal touch.",
          "title": "How do I sort and upload my graduation photos?"
        },
        "photo-books-graduation-templates-layouts": {
          "content": "Our photo books feature a single layout with one photo per page, ensuring every memory is given the spotlight it deserves. This simple yet effective layout allows each image to stand out, making it ideal for capturing the essence of your graduation journey. With our easy editing tools, you can crop and rearrange photos to fit your desired narrative.",
          "title": "What templates or layouts work well for a graduation book?"
        },
        "photo-books-birthday-important-moments": {
          "content": "Capturing the essence of a birthday celebration in a birthday photo book involves focusing on key moments like the cake cutting, gift opening, and interactions with guests. These moments highlight the joy and excitement of the day, making them essential for a comprehensive birthday photo book. At Mixtiles, our photo books allow you to relive these cherished memories with each page turn.",
          "title": "What moments are important to capture in a birthday photo book?"
        },
        "photo-books-birthday-photograph-party": {
          "content": "To create a stunning birthday photo book, take a mix of wide shots and close-ups. Capture the entire room to set the scene and zoom in on details like decorations and facial expressions. Our photo books are crafted from velvety, silk-feel paper, ensuring every photo, from the big picture to the smallest detail, shines with vibrant color.",
          "title": "How do I photograph a birthday party to make a great photo book?"
        },
        "photo-books-birthday-candid-vs-posed": {
          "content": "While posed photos have their place, candid shots often capture the genuine joy and spontaneity of a birthday party. Focus on snapping moments of laughter, surprise, and interaction for a more authentic portrayal. With Mixtiles' easy editing features, you can arrange these candid shots to create a narrative that truly reflects the spirit of the celebration.",
          "title": "Should I focus on candid shots or posed photos?"
        },
        "photo-books-birthday-details-include": {
          "content": "Include details such as decorations, the birthday cake, and the smiles of attendees to add depth to your birthday photo book. These elements help paint a full picture of the event, making your photo book a vibrant keepsake. Our customizable photo books allow you to spotlight each of these details with a single photo per page layout.",
          "title": "What details should I include?"
        },
        "photo-books-birthday-tell-story": {
          "content": "To ensure your birthday photos tell a story, arrange them in chronological order, from the arrival of guests to the final goodbyes. This sequence helps to naturally narrate the day's events. At Mixtiles, we offer a seamless one-tap creation process that organizes your photos into a cohesive story, with the option for further customization.",
          "title": "How can I make sure the birthday photos tell a story?"
        },
        "photo-books-birthday-angle-focus": {
          "content": "Having a theme or focus, such as a color scheme or party motif, can add a unique angle to your birthday photo book. This theme can guide your photo selection and arrangement, creating a more visually appealing and cohesive book. Our photo books' sleek, matte-finished hardcover complements any theme you choose, adding elegance to your personalized keepsake.",
          "title": "Is it helpful to have an \"angle\" or focus for the event?"
        },
        "photo-books-birthday-subjects-interest": {
          "content": "Subjects like party games, special outfits, and unique guest interactions can create interest on each page of your birthday photo book. These elements bring variety and excitement, making each page turn a delightful surprise. With Mixtiles' premium quality photo books, each photo gets the spotlight it deserves, ensuring your memories are preserved beautifully.",
          "title": "What subjects create interest on each page?"
        },
        "photo-books-birthday-how-many-photos": {
          "content": "For a balanced birthday photo book, consider including between 50 to 100 photos. This range allows you to capture the full scope of the event without overwhelming the viewer. Mixtiles' photo books accommodate up to 150 photos, giving you the flexibility to include all your favorite moments while maintaining a clean, organized layout.",
          "title": "How many photos should I include from the party?"
        },
        "photo-books-retirement-how-create": {
          "content": "Creating a retirement photo book with Mixtiles is a simple and enjoyable process. Start by uploading a minimum of 24 photos through our website or app, showcasing up to {{max_photos}} cherished memories. Our intuitive platform organizes your images automatically, but you can personalize the layout to tell a unique story. Each page features one photo, allowing every moment to shine. With our premium quality, velvety, silk-feel paper and elegant matte-finished hardcover, your retirement photo book will be a beautiful keepsake for your colleague or loved one.",
          "title": "How do I create a retirement photo book for a colleague or loved one?"
        },
        "photo-books-retirement-when-start-planning": {
          "content": "We recommend starting the planning process at least a month in advance. This allows ample time to gather meaningful photos and contributions from coworkers, ensuring a comprehensive and heartfelt retirement photo book. By planning early, you can also take advantage of our easy editing features to arrange and customize your photos perfectly. Remember, you can save your selections temporarily on our platform and finalize your masterpiece when ready.",
          "title": "When should I start planning a retirement photo book?"
        },
        "photo-books-retirement-types-photos": {
          "content": "A retirement photo book should capture the essence of the retiree's career and personality. Include a mix of career highlights, such as significant projects, awards, and promotions, alongside candid office moments that reflect their daily interactions and friendships. Our photo books allow you to crop and arrange images, so each photo fits perfectly with the narrative you want to create.",
          "title": "What types of photos should I include?"
        },
        "photo-books-retirement-coworkers-contribute": {
          "content": "Absolutely! Inviting coworkers to contribute photos and personal messages adds depth and warmth to the retirement photo book. It's a wonderful way to include diverse perspectives and memories. At Mixtiles, we encourage collaboration, and our platform makes it easy to upload and organize contributions from multiple sources.",
          "title": "Should I ask coworkers to contribute photos and messages?"
        },
        "photo-books-retirement-humor-personal-touches": {
          "content": "Adding humor and personal touches can make your retirement photo book truly special. Consider including funny advice, office jokes, or memorable quotes from the retiree's career. You might also incorporate photos of office memorabilia or events that were particularly meaningful. Our customization options allow you to easily edit text and images, ensuring your personal touches are perfectly integrated.",
          "title": "How can I add humor or personal touches?"
        },
        "photo-books-retirement-layout-ideas": {
          "content": "A timeline of career milestones is a fantastic way to structure a retirement photo book. Begin with early career moments and progress through to retirement, highlighting significant achievements and transitions. Our one-photo-per-page layout ensures each milestone is given the attention it deserves, and you can rearrange photos with ease to create a coherent narrative.",
          "title": "What layout ideas can make it special?"
        },
        "photo-books-retirement-photo-quality": {
          "content": "Photo quality is crucial for a stunning retirement photo book. We recommend using images with a resolution between 600 x 600 pixels and 7000 x 7000 pixels to ensure clarity and vibrancy. Our platform will notify you if any photos don't meet these standards, allowing you to select the best possible images for your book.",
          "title": "How important is photo quality for a retirement album?"
        },
        "photo-books-retirement-meaningful-gifts": {
          "content": "Retirement photo books are meaningful gifts because they encapsulate a retiree's career journey and personal connections. They offer a tangible way to reflect on achievements and cherished memories, making them a heartfelt tribute to a colleague or loved one. At Mixtiles, we ensure your retirement photo book is a premium, personalized keepsake that will be treasured for years to come.",
          "title": "Why are retirement photo books meaningful gifts?"
        },
        "photo-books-fathers-day-great-gift": {
          "content": "A photo book is a fantastic Father's Day gift because it captures cherished memories and personal moments that celebrate your dad's unique journey. We offer beautifully bound photo books that allow you to compile family moments, vacations, and milestones into a keepsake that Dad can treasure forever. Our photo books are crafted with high-quality materials, making them a durable and elegant gift that stands the test of time.",
          "title": "Why is a photo book a great Father's Day gift?"
        },
        "photo-books-fathers-day-memories-include": {
          "content": "When creating a Father's Day photo book, consider including a mix of memories that highlight different aspects of your dad's life. Baby photos, family trips, and milestone events are all great choices. Our photo books allow you to feature one photo per page, ensuring each memory gets the spotlight it deserves. With our easy editing tools, you can crop and arrange photos to perfectly tell your story.",
          "title": "What memories should I include?"
        },
        "photo-books-fathers-day-make-special": {
          "content": "To make your photo book extra special for Dad, consider using a \"Then and Now\" theme. Start with childhood photos and progress through significant life events, ending with recent family gatherings or achievements. You can also personalize the cover with a meaningful photo and customize the text to summarize your story. At Mixtiles, we make it easy to create a personalized keepsake that Dad will cherish.",
          "title": "How can I make the photo book special for Dad?"
        },
        "photo-books-fathers-day-involve-children": {
          "content": "Involving children in creating the photo book can add a heartfelt touch. Encourage them to contribute drawings or write short notes that can be scanned and included in the book. This not only adds a personal element but also makes the gift a collaborative family project. At Mixtiles, we support your creative freedom, allowing you to design a truly unique Father's Day photo book.",
          "title": "Should I involve children in making the book?"
        },
        "photo-books-fathers-day-format-recommended": {
          "content": "Our photo books come with a sleek, matte-finished hardcover that offers both durability and elegance. Unlike traditional leather albums or softcovers, our hardcover books are printed on velvety, silk-feel paper that minimizes reflections and keeps colors vibrant. This format provides a premium feel while ensuring your memories are preserved beautifully.",
          "title": "What format is recommended?"
        },
        "photo-books-fathers-day-who-book-for": {
          "content": "A Father's Day photo book is a versatile gift suitable for new dads, grandads, and every father figure in between. Whether it's celebrating a first Father's Day or honoring years of fatherhood, our photo books can be tailored to fit any dad's story. With sizes ranging from {{v1}} to {{v3}}, you can choose the perfect format for your recipient.",
          "title": "Who is this book for?"
        },
        "photo-books-fathers-day-how-many-photos": {
          "content": "Our photo books can showcase between 24 to {{max_photos}} photos, with one photo per page. This flexibility allows you to create a comprehensive or concise collection, depending on your preference.",
          "title": "How many photos or pages to include?"
        },
        "photo-books-fathers-day-nostalgic-photos": {
          "content": "Absolutely! Nostalgic family photos are perfect for a Father's Day photo book. Our platform allows you to upload photos with a minimum resolution of 600 x 600 pixels to ensure clarity. Relive those cherished memories with our premium quality prints, bringing your family history to life with each page turn.",
          "title": "Can I use nostalgic family photos in the Father's Day book?"
        },
        "photo-books-pet-dog-create-personalized": {
          "content": "Creating a personalized dog photo album with Mixtiles is a breeze! Simply upload your favorite dog photos to our website or app, and our intuitive platform will automatically organize them into a stunning photo book. You can further customize by rearranging photos, cropping, and adding personal touches to make it truly unique. Our photo books are printed on velvety, silk-feel paper with a durable matte-finished hardcover, ensuring your memories last a lifetime.",
          "title": "How do I create a personalized dog photo album?"
        },
        "photo-books-pet-dog-photos-include": {
          "content": "When creating your dog photo album, think about capturing a range of moments that showcase your pet's personality and your shared experiences. Include photos of daily antics, playful moments, and those quiet times that capture your dog's unique character. Our platform allows you to upload between 24 to {{max_photos}} photos, giving you plenty of space to tell your story.",
          "title": "What photos should I include in my dog's album?"
        },
        "photo-books-pet-dog-puppy-family-photos": {
          "content": "Absolutely! Including puppy photos alongside family pictures can create a heartwarming narrative in your dog photo book. We encourage you to mix and match different stages of your pet's life with family milestones, creating a comprehensive keepsake that celebrates your furry friend as part of the family.",
          "title": "Can I include my pet's puppy photos and family pictures?"
        },
        "photo-books-pet-dog-choose-best-photos": {
          "content": "To choose the best photos for your dog photo album, focus on high-quality images that evoke emotion and tell a story. Ensure your photos meet our recommended resolution of 600 x 600 pixels to 7000 x 7000 pixels for the best print quality. You can also use our easy editing tools to crop and enhance images, ensuring each page of your photo book is picture-perfect.",
          "title": "How do I choose the best dog photos for the album?"
        },
        "photo-books-pet-dog-why-make-album": {
          "content": "Creating a photo album for your dog is a wonderful way to celebrate and preserve the special bond you share. It serves as a personal keepsake, allowing you to relive cherished moments and milestones. Whether displayed on your coffee table or shared with loved ones, a dog photo book is a meaningful way to honor your pet's place in your life.",
          "title": "Why make a photo album for my dog?"
        },
        "photo-books-pet-dog-templates-design-ideas": {
          "content": "While Mixtiles does not offer specific templates, our one-tap creation process simplifies the design of your dog photo book. Once photos are uploaded, they're automatically organized into a sleek layout, which you can customize further. This flexibility allows your creativity to shine, ensuring your album reflects your personal style and your dog's unique story.",
          "title": "Are there templates or design ideas for a dog photo book?"
        },
        "photo-books-pet-dog-include-milestones": {
          "content": "Including milestone moments like your dog's \"first walk\" or \"first Christmas\" adds depth and significance to your photo album. These events highlight your pet's growth and the memorable experiences you share. We offer a single photo per page layout, allowing each milestone to take center stage and be celebrated in its own right.",
          "title": "Should I include photos of milestones like \"first walk\" or \"first Christmas\"?"
        },
        "photo-books-pet-dog-gift-idea": {
          "content": "Yes, a personalized dog photo album makes a thoughtful and unique gift for any pet lover. At checkout, you can order multiple copies of your photo book, making it easy to share your creation with friends and family. Each copy will be an identical match to the original, ensuring everyone can enjoy the same delightful memories of your beloved pet.",
          "title": "Can I use my dog's album as a gift idea for a pet lover?"
        },
        "photo-books-anniversary-great-gift": {
          "content": "An anniversary photo book is a timeless gift that beautifully captures the essence of your shared journey. At Mixtiles, we offer personalized keepsakes that allow you to curate a collection of your favorite moments into a sleek, beautifully bound book. Each page turn lets you relive cherished memories, making it a perfect way to celebrate your love story.",
          "title": "Why is a photo book a great anniversary gift?"
        },
        "photo-books-anniversary-memories-include": {
          "content": "Include a mix of significant milestones and everyday moments to create a well-rounded narrative. Think about the first photo you took together, special vacations, and memorable celebrations. Our easy editing tools allow you to arrange these photos seamlessly, ensuring your anniversary photo album tells your unique story.",
          "title": "What memories should I include in an anniversary photo book?"
        },
        "photo-books-anniversary-how-many-photos": {
          "content": "While you can include anywhere from 24 to {{max_photos}} photos, the ideal number depends on the story you wish to tell. Each of our photo books features a single layout with one photo per page, ensuring every memory gets the spotlight it deserves. This format helps maintain a clean and elegant presentation.",
          "title": "How many photos are ideal for an anniversary photo book?"
        },
        "photo-books-anniversary-everyday-candid-moments": {
          "content": "Absolutely! Including candid moments adds authenticity to your anniversary photo book. These everyday snapshots often capture the true essence of your relationship, providing a genuine glimpse into your shared life. At Mixtiles, we believe every moment is worth celebrating.",
          "title": "Should I include everyday or candid moments too?"
        },
        "photo-books-anniversary-personal-unique": {
          "content": "Personalize your anniversary photo album by selecting a special cover photo and customizing the text to summarize your story. Our platform allows you to crop and arrange photos to fit your narrative perfectly. With our premium quality, silk-feel pages, your book will not only look stunning but also feel unique to your relationship.",
          "title": "How do I make an anniversary book personal and unique?"
        },
        "photo-books-anniversary-any-year-celebration": {
          "content": "Yes, anniversary photo books are perfect for any year of celebration. Whether it's your first or fiftieth anniversary, our books are designed to enhance the beauty of your memories with durable, matte-finished covers. They are a meaningful way to commemorate your journey together, year after year.",
          "title": "Are anniversary photo books good for any year of celebration?"
        },
        "photo-books-anniversary-photo-quality": {
          "content": "To ensure the best, clearest prints, use photos with a resolution between 600 x 600 pixels and 7000 x 7000 pixels. Our platform will notify you if any uploaded photos don't meet these standards, allowing you to select alternatives for a picture-perfect anniversary photo book.",
          "title": "What photo quality should I use for an anniversary album?"
        },
        "photo-books-anniversary-tell-love-story": {
          "content": "Start by organizing your photos chronologically or thematically to reflect your journey. Use our one-tap creation process to upload and arrange your photos effortlessly. With Mixtiles, you have the creative freedom to craft an anniversary photo album that beautifully narrates your love story, making it a cherished keepsake for years to come.",
          "title": "How can I tell our love story through the anniversary photo book?"
        },
        "photo-books-mothers-day-perfect-gift": {
          "content": "A photo book is a perfect Mother's Day gift because it captures cherished memories in a tangible form that can be revisited time and again. At Mixtiles, we offer beautifully bound photo books that allow you to create a personalized keepsake. Unlike a traditional mother's day photo album, our photo books feature a sleek, matte-finished hardcover and pages made from velvety, silk-feel paper, ensuring a premium quality gift that your mom will treasure.",
          "title": "Why is a photo book a perfect Mother's Day gift?"
        },
        "photo-books-mothers-day-memories-include": {
          "content": "When creating a mother's day photo book, consider including a mix of family moments, vacation highlights, and milestone events. These memories help illustrate the journey and bond you share with your mom. Our easy editing tools allow you to organize your photos exactly how you want them, ensuring every memory gets the spotlight it deserves.",
          "title": "What memories should I put in a Mother's Day photo book?"
        },
        "photo-books-mothers-day-personalize-book": {
          "content": "Personalizing your mother's day photo book is simple with Mixtiles. You can add captions and notes to each page, providing context and heartfelt messages that enhance the emotional impact of your gift. Choose a special photo for the front cover and customize the text to summarize your unique story, adding a personal touch that will make the book truly one-of-a-kind.",
          "title": "How can I personalize the book for Mom?"
        },
        "photo-books-mothers-day-creative-themes": {
          "content": "Creative themes for a Mother's Day photo book can range from \"A Year in Review\" to \"Generations of Love,\" or even \"Mom's Favorite Moments.\" Each book features a single layout with one photo per page, allowing you to tell a cohesive story. Our user-friendly platform even organizes your photos automatically, making it easy to create a stunning photo book with just a few taps.",
          "title": "What creative themes work for a Mother's Day photo book?"
        },
        "photo-books-mothers-day-shared-activities": {
          "content": "Absolutely! Including photos of shared activities and special moments is essential for a meaningful mother's day photo book. These images capture the essence of your relationship and highlight the experiences that have brought you closer together. Our photo books are designed to showcase these precious memories with vibrant colors and high-quality prints.",
          "title": "Should I include photos of shared activities and special moments?"
        },
        "photo-books-mothers-day-how-far-back": {
          "content": "There's no strict rule for how far back you should go when selecting photos for your mother's day photo book. Consider including a mix of recent and older photos that tell the story of your relationship over time. With Mixtiles, you can upload up to {{max_photos}} photos, giving you plenty of room to include a comprehensive collection of your favorite memories.",
          "title": "How far back in time should I go with photos?"
        },
        "photo-books-mothers-day-quotes-messages": {
          "content": "Yes, adding quotes or heartfelt messages is a wonderful way to personalize your mother's day photo book. Whether it's a favorite saying of your mom's or a quote that resonates with your relationship, these additions can enhance the emotional depth of your gift. Our platform allows you to easily incorporate text alongside your images.",
          "title": "Can I add quotes or heartfelt messages in the photo book?"
        },
        "photo-books-mothers-day-creation-steps": {
          "content": "Creating a custom mother's day photo book with Mixtiles is straightforward. Start by uploading a minimum of 24 photos on our website or app. Our unique one-tap creation process organizes the photos for you, but you have the freedom to customize further. Once your book is ready, you can order it directly through our platform. If you need assistance, our customer support team is available via email or live chat to help you every step of the way.",
          "title": "What steps are involved in creating a custom Mother's Day photo book?"
        },
        "photo-books-deals-current-available": {
          "content": "At Mixtiles, we regularly offer exciting photo book deals to help you save on personalized memories. Most of our discounts range between 15% and 20% off, and they're often available during seasonal events, holidays, or special campaigns. The best part? You don't need to hunt for a code—our current promotion is automatically applied to your cart when it's active. Simply start building your book and you'll see the deal reflected at checkout.\n\nOur photo books are not only beautifully crafted, but also incredibly easy to create thanks to our one-tap creation process. Upload your favorite moments, and we'll organize them into a ready-to-order book—no complicated editing required (unless you want to!).",
          "title": "What are the current photo book deals available at Mixtiles?"
        },
        "photo-books-deals-apply-promo-code": {
          "content": "While many of our photo book deals are applied automatically, you may occasionally receive a promo code via email or social media. To apply one manually:<ol><li>Tap the menu icon (☰) in the upper corner of our website or app.</li><li>Select Promo Code.</li><li>Click Add Promo Code at the bottom of the screen.</li><li>Enter your code and hit Done.</li></ol>It's that simple. Once the code is applied, you'll see your discount instantly in your cart. If the promo code doesn't work, make sure it hasn't expired and isn't being combined with another offer.",
          "title": "How do I apply a promo code to get a photo book deal?"
        },
        "photo-books-deals-combine-multiple": {
          "content": "Our system supports one promotion per order. While we love giving our customers great deals, photo book discounts can't be stacked or combined. If you happen to have more than one valid code, we recommend saving the second one for your next book.\n\nWe aim to keep things simple—just like our photo books—so you don't need to juggle codes to get a great price.",
          "title": "Can I combine multiple photo book deals or codes?"
        },
        "photo-books-deals-bigger-orders": {
          "content": "We've built our pricing model differently. At Mixtiles, our photo books are offered at a fixed price, regardless of how many pages you include. That means you can add more memories without worrying about extra costs.\n\nUnlike many competitors, we don't charge per page. This makes our pricing structure simple and transparent—so there's less need for extra volume-based deals. Whether your book has 20 photos or 80, your price stays the same.",
          "title": "Why don't photo book deals get better with bigger orders?"
        },
        "photo-books-deals-stay-updated": {
          "content": "To be the first to hear about our latest photo book deals, we recommend:<ul><li>Signing up for our email updates at <a href=\"https://www.mixtiles.com/getstarted\" target=\"_blank\" rel=\"noopener noreferrer\">www.mixtiles.com/getstarted</a></li><li>Following us on Instagram and Facebook, where we share exclusive offers with our community</li></ul>Our subscribers often receive early access to limited-time promotions and special discounts. Whether you're looking to print a recent trip or create a meaningful gift, staying connected ensures you never miss a great deal.",
          "title": "How can I stay updated on future photo book deals?"
        },
        "photo-books-christmas-why-make": {
          "content": "Creating a Christmas photo book allows you to preserve holiday memories in a tangible format. We offer beautifully bound photo books that let you relive each special moment, from decorating the tree to festive family dinners. Our photo books are not just collections of images; they are keepsakes that capture the joy and warmth of the holiday season.",
          "title": "Why make a Christmas photo book?"
        },
        "photo-books-christmas-photos-include": {
          "content": "A Christmas photo book should include photos that capture the essence of your holiday celebrations. Consider including images of tree decorating, gift opening, and family dinners. These moments are integral to the Christmas spirit, and our premium quality photo books, printed on velvety, silk-feel paper, will bring these memories to life with vibrant colors.",
          "title": "What photos should I include in a Christmas album?"
        },
        "photo-books-christmas-theme-book": {
          "content": "Theming your Christmas photo book can add an extra layer of personalization. Popular themes include \"Winter Wonderland,\" featuring snowy landscapes and cozy indoor scenes, or \"Home for the Holidays,\" highlighting heartwarming family moments. With Mixtiles, you have the creative freedom to arrange and theme your photos exactly how you envision them.",
          "title": "How do I theme a Christmas photo book?"
        },
        "photo-books-christmas-decorations-captions": {
          "content": "Adding Christmas decorations or captions can enhance your photo book's storytelling. Our easy editing tools allow you to personalize each page with captions or decorative elements that complement your photos. Whether you choose to add a festive border or a heartfelt quote, these additions can make your Christmas photo book even more special.",
          "title": "Should I add Christmas decorations or captions to the pages?"
        },
        "photo-books-christmas-snowy-outdoor-photos": {
          "content": "Absolutely! Including snowy or outdoor winter photos can add variety and depth to your Christmas photo book. Our photo books are designed to highlight each memory with a single photo per page, ensuring that even the smallest details in your outdoor winter photos are beautifully showcased.",
          "title": "Can I include snowy or outdoor winter photos in the Christmas book?"
        },
        "photo-books-christmas-creative-ideas": {
          "content": "For a creative touch, consider using stickers and quotes in your Christmas photo book. We provide tools to customize your book, allowing you to add personal touches that reflect your holiday spirit. These creative elements can transform your photo book into a unique holiday masterpiece.",
          "title": "What are some creative Christmas photo book ideas?"
        },
        "photo-books-christmas-meaningful-gift": {
          "content": "A Christmas photo book makes a meaningful gift by offering a personalized collection of memories that can be cherished for years to come. Our photo books, with their sleek, matte-finished hardcovers, are perfect for sharing stories and experiences with loved ones, making them a thoughtful and heartfelt gift option.",
          "title": "How can a Christmas photo book be a meaningful gift?"
        },
        "photo-books-christmas-creation-steps": {
          "content": "Creating a Christmas photo book with Mixtiles is simple and intuitive. Start by choosing a theme and selecting your favorite holiday photos. Upload a minimum of 24 photos through our website or app, and our one-tap creation process will organize them into a ready-to-order book. You can further customize your book to ensure it reflects your unique holiday story.",
          "title": "What steps do I follow to create a Christmas photo book?"
        },
        "photo-books-12x12-sizes-formats": {
          "content": "We offer our photo books in three sizes, including the impressive {{size_display}} format. This size is perfect for those who want a bold, eye-catching display. Our {{size_display}} photo books come with a sleek, matte-finished hardcover that ensures durability and elegance.",
          "title": "What sizes and formats do {{size_display}} photo books come in?"
        },
        "photo-books-12x12-pages-contain": {
          "content": "Our {{size_display}} photo books can showcase between 24 and {{max_photos}} of your favorite memories, with one photo per page to give each moment the spotlight it deserves. This range allows you to create anything from a brief snapshot of a special event to an extensive photo collection.",
          "title": "How many pages can a {{size_display}} photo book contain?"
        },
        "photo-books-12x12-cover-materials": {
          "content": "We craft our {{size_display}} photo books with premium materials, featuring velvety, silk-feel paper that enhances your photos' vibrancy. The hardcover is coated with a thin matte film, adding durability and a touch of sophistication to your personalized keepsake.",
          "title": "What cover materials are available for {{size_display}} books?"
        },
        "photo-books-12x12-lay-flat-hardcover": {
          "content": "Our photo books are hardcover, providing a sturdy and lasting way to preserve your memories. While they are not lay-flat, the hardcover ensures your photos are well-protected and beautifully presented.",
          "title": "Are {{size_display}} photo books lay-flat or hardcover?"
        },
        "photo-books-12x12-good-for": {
          "content": "A {{size_display}} photo book is ideal for a coffee table display, making it a centerpiece that invites guests to flip through your cherished moments. Its larger format is perfect for big spreads, allowing detailed photos to shine and tell your story vividly.",
          "title": "What is a {{size_display}} photo book good for?"
        },
        "photo-books-12x12-compare-smaller": {
          "content": "Compared to smaller sizes, the {{size_display}} photo book offers a more expansive canvas for your photos, making it perfect for detailed images and comprehensive storytelling. This larger format ensures that every detail is captured and appreciated.",
          "title": "How do {{size_display}} books compare to smaller sizes?"
        },
        "photo-books-12x12-price-range": {
          "content": "Due to its size and premium materials, the {{size_display}} photo book is typically priced higher than smaller options. However, the investment is worthwhile for those seeking a high-quality, impactful showcase of their memories.",
          "title": "What price range do {{size_display}} photo books have?"
        },
        "photo-books-12x12-professional-portfolio": {
          "content": "Absolutely! Our {{size_display}} photo books are well-suited for professional or portfolio albums. With premium printing and customizable layouts, they provide a polished and impressive way to present your work or special projects.",
          "title": "Can I use a {{size_display}} format for professional or portfolio albums?"
        },
        "photo-books-8x8-what-makes-special": {
          "content": "An {{size_display}} photo book is a compact, square-format book that beautifully showcases your favorite memories. At Mixtiles, we offer photo books with a sleek, matte-finished hardcover and pages made from velvety, silk-feel paper. This format is perfect for those who want a manageable size without compromising on quality, allowing you to relive cherished moments with each turn of the page.",
          "title": "What is an {{size_display}} photo book and what makes it special?"
        },
        "photo-books-8x8-mix-portrait-landscape": {
          "content": "Yes, you can mix both portrait and landscape photos in your {{size_display}} photo book. Our easy editing tools allow you to zoom, crop, and rearrange your images to fit perfectly within the layout. Each page features one photo, ensuring that every memory gets the spotlight it deserves.",
          "title": "Can I mix portrait and landscape photos in an {{size_display}} book?"
        },
        "photo-books-8x8-cover-options": {
          "content": "Our {{size_display}} photo books come with a premium matte-finished hardcover that adds durability and elegance. You can personalize the cover by choosing a special photo and editing the \"Happy Moments\" text to make it uniquely yours. This customization adds a personal touch that summarizes your story beautifully.",
          "title": "What cover options are there for {{size_display}} photo books?"
        },
        "photo-books-8x8-good-occasions": {
          "content": "An {{size_display}} photo book is ideal for a variety of occasions, such as family gatherings, vacations, weddings, or milestone events. The compact size makes it a perfect keepsake or gift, capturing the essence of your special moments in a format that's easy to share with loved ones.",
          "title": "What occasions is an {{size_display}} photo book good for?"
        },
        "photo-books-8x8-pages-have": {
          "content": "Our {{size_display}} photo books can accommodate between 24 to {{max_photos}} pages, allowing you to showcase a wide range of memories. This flexibility ensures that whether you have a small collection or an extensive array of photos, your story can be told just the way you want it.",
          "title": "How many pages can an {{size_display}} photo book have?"
        },
        "photo-books-8x8-square-format-display": {
          "content": "Yes, the {{size_display}} photo book is a square format, making it easy to display on coffee tables, shelves, or desks. Its compact size and stylish design make it a versatile addition to any space, providing a convenient way to enjoy your favorite photos.",
          "title": "Are {{size_display}} photo books square format and easy to display?"
        },
        "photo-books-8x8-templates-styles": {
          "content": "At Mixtiles, we offer a streamlined, one-tap creation process that automatically organizes your photos into a cohesive layout. While we don't offer multiple templates, our intuitive platform allows for easy customization, so you can adjust the order and cropping of your photos to create a style that suits your taste.",
          "title": "What kinds of templates or styles are available for {{size_display}} books?"
        },
        "photo-books-8x8-why-choose": {
          "content": "Choosing an {{size_display}} photo book offers the perfect balance between portability and displayability. It's large enough to showcase your photos beautifully while being compact enough to handle and store easily. This size is particularly popular for those who want a versatile book that fits seamlessly into any setting.",
          "title": "Why choose an {{size_display}} photo book instead of a larger or smaller size?"
        },
        "photo-books-recipe-what-is": {
          "content": "A recipe photo book is a unique and personalized way to compile your favorite recipes alongside stunning photographs. Much like a traditional cookbook, it allows you to showcase both the recipes and the visual appeal of the dishes. At Mixtiles, we offer sleek, beautifully bound photo books that can transform your culinary collection into a keepsake. With our easy editing tools, you can curate a recipe photo book that not only tells the story of your culinary journey but also becomes a visual delight for anyone flipping through its pages.",
          "title": "What is a recipe photo book and how is it used?"
        },
        "photo-books-recipe-old-family-recipes": {
          "content": "Incorporating old family recipes into your recipe photo book is a wonderful way to preserve cherished culinary traditions. Simply scan the handwritten recipes and upload them as images. Our platform allows you to seamlessly integrate these scans alongside photos of the finished dishes or family members cooking together, creating a heartfelt connection between past and present.",
          "title": "How do I include old family recipes?"
        },
        "photo-books-recipe-themes": {
          "content": "There are endless possibilities when it comes to themes for your recipe photo book. Consider focusing on holiday recipes, which capture the essence of festive gatherings, or create a book dedicated to desserts, showcasing sweet treats with vibrant photos. You could also explore themes like budget meals, where you provide cost-effective recipes without compromising on taste. Whatever theme you choose, our photo books provide the perfect canvas to bring your culinary vision to life.",
          "title": "What themes can I use for a recipe photo book?"
        },
        "photo-books-recipe-organize": {
          "content": "Organizing your recipes can be done in various ways, depending on your preference. You might choose to arrange them chronologically, reflecting your culinary evolution, or categorize them by type, such as appetizers, main courses, and desserts. At Mixtiles, we offer a user-friendly platform where you can easily rearrange pages and photos to suit your organizational style, ensuring your recipe photo book is as functional as it is beautiful.",
          "title": "How should I organize recipes in the book?"
        },
        "photo-books-recipe-layout-details": {
          "content": "Each recipe in your photo book should include a clear title, a list of ingredients, step-by-step instructions, and accompanying photos. Our photo books provide a single layout with one photo per page, allowing you to highlight each dish's beauty. You can also add personal notes or tips to make the recipes more engaging and informative.",
          "title": "What layout details does each recipe need?"
        },
        "photo-books-recipe-cooking-process-photos": {
          "content": "Absolutely! Including photos of the cooking process or the finished dishes adds depth and context to your recipe photo book. Our premium quality photo books ensure that these images are printed on velvety, silk-feel paper, bringing each photo to life with rich color and detail. This visual storytelling enhances the reader's experience and makes your book a joy to explore.",
          "title": "Can I add photos of the cooking process or finished dishes?"
        },
        "photo-books-recipe-family-heirloom": {
          "content": "Yes, a recipe photo book is an excellent family heirloom. It preserves your family's culinary history and can be passed down through generations. By capturing both the recipes and the stories behind them, you create a timeless keepsake that celebrates your family's love for food and tradition. Our durable photo books, with matte-finished hardcovers, ensure that your heirloom will last for years to come.",
          "title": "Is a recipe photo book a good family heirloom?"
        },
        "photo-books-recipe-make-engaging": {
          "content": "To make your recipe photo book truly engaging, consider adding personal notes, anecdotes, or pro tips alongside each recipe. These elements provide insight into the significance of each dish and make the book more interactive. We encourage you to personalize your photo book to reflect your unique culinary journey, making it a memorable experience for anyone who reads it.",
          "title": "How can I make the book engaging?"
        },
        "shipping-location": {
          "content": "Yes, to most countries in the world!",
          "title": "Do you ship internationally?"
        },
        "shipping-time": {
          "content": "Usually about a week. Expedited options are available in some countries. We will update you with a tracking number after your purchase",
          "title": "How long does shipping take?"
        },
        "title": "Frequently Asked Questions",
        "walls": {
          "content": "Nope, no damage",
          "title": "And they won't hurt my walls?"
        }
      },
      "fullscreen_title": "Museum-Quality Prints from Your Phone",
      "fullscreen_title_desktop": "Museum-Quality Prints",
      "made_in_canada": "Made in Canada",
      "main_button_cta": "Shop Now",
      "photo_wall": {
        "subtitle": "Pick the perfect style for your home",
        "title": "Create a Photo Wall in a Few Taps"
      },
      "secondary_title_1": "Say Goodbye to Hammers & Nails",
      "secondary_title_1_desktop": "Just peel and stick",
      "secondary_title_2": "Adjust to Perfection",
      "secondary_title_3": "Leaves No Marks",
      "meet_magnetic_hanging": "Meet Magnetic Hanging",
      "seen-on": "As Seen On",
      "seen-on-desktop": "As seen on",
      "simple_price": {
        "subtitle": "Our pricing is honest, with no hidden fees, and shipping is always free.",
        "title": "Same Price, No Matter How Many Pages"
      },
      "simple_price_tiers": {
        "from_label": "From",
        "subtitle": "Our books come in simple price tiers based on size and page count, with free shipping.",
        "title": "Simple Pricing, No Surprises"
      },
      "title": "Photo Walls Reinvented",
      "try_now": {
        "continue": "Continue Your Book",
        "subtitle": "Design your book with just a few taps and see it come to life in 3D",
        "title": "Photo Books Made Easy",
        "design_subtitle": "Turn your trips into stunning coffee table books in a few taps",
        "design_title": "Travel Books Made Easy",
        "life_events_subtitle": "Turn life's biggest moments into coffee table books in just a few taps.",
        "life_events_title": "A Beautiful Book for Every Milestone",
        "create_now": "Create Now"
      },
      "email_signup": {
        "title": "Be the first to know — deals, news & decor ideas.",
        "email_label": "Email address",
        "terms_text": "By clicking you agree to the Terms of Use & Privacy Policy",
        "success_message": "Thank you for your subscription"
      }
    },
    "login": {
      "last_used": "Last used",
      "continue_with": "Continue with",
      "create_account_error": "Error creating account",
      "error_dialog": {
        "incorrect_email_or_code_message": "Either the email or the code you entered is incorrect. Please try to re-enter the code, or re-enter your email and try again.",
        "incorrect_email_or_code_title": "Incorrect email or code",
        "login_unsuccessful_message": "Please try again or contact support for help",
        "login_unsuccessful_title": "Login unsuccessful",
        "too_many_incorrect_attempts_message": "Please check your email to unblock your account.",
        "too_many_incorrect_attempts_title": "Too many incorrect attempts"
      },
      "email_capture_placeholder": "Enter Email",
      "email_code": {
        "code_sent": "Code Sent to Email",
        "code_sent_detailed": "An email with the code has been sent to {{email}}",
        "resend_code": "Resend Code",
        "resend_code_countdown": "Resend available in {{seconds}}s",
        "enter_code": "Enter Code"
      },
      "login": "Login",
      "login_message": "{{v1}} to save your progress & track orders",
      "login_or_sign_up": "Login or Sign Up",
      "login_successfully": "You're logged in!",
      "no_email_error": "You must provide access to your email in order to create an account.",
      "register_successfully": "Welcome! Registration completed",
      "restored_photo": "Your saved photo was restored",
      "restored_photos": "Your saved photos were restored",
      "restricted": {
        "title": "Login to Check Your Orders"
      },
      "sign_out": "Sign Out",
      "sign_up": "Sign up",
      "start_your_design_journey": "Start Your Design Journey",
      "terms_of_use": {
        "and": "and",
        "privacy_policy": "Privacy Policy",
        "terms_of_use": "Terms of Use",
        "terms_of_use_intro": "By signing up you agree to our"
      },
      "verify_email_dialog": {
        "button": "I'll do it later",
        "content": "We sent an email to {{v1}} so we can make sure it's really you and show you all your previous orders.",
        "title": "Check Your Inbox"
      }
    },
    "logout": {
      "signed_out_successfully": "Signed out successfully",
      "signed_out_successfully_subtitle": "Log back in to see your saved photos"
    },
    "multi_product_homepage": {
      "photo_walls_title": "Photo Walls",
      "photo_walls_subtitle": "Turn your photos into stunning wall art",
      "photo_books_subtitle": "Design your book with a few taps",
      "pet_portraits_subtitle": "Funny & artistic portrait photos",
      "shop_now": "Shop Now",
      "continue_designing": "Continue Designing",
      "explore_now": "Explore Now",
      "download": "Download",
      "app_title": "The New Mixtiles App",
      "app_subtitle": "We turn your best moments into ready made photo products, automatically.",
      "app_store_badge": "Download on the App Store",
      "get_app_title": "Get the new Mixtiles App",
      "new_products_title": "Try Our New Products",
      "desktop_new_products_title": "Products",
      "new_products": {
        "caricature": "Caricature",
        "the_studio": "The Studio"
      },
      "best_place_title": "The Best Place to Print Your Photos",
      "stats": {
        "rating_caption": "156K+ reviews",
        "customers_caption": "Happy customers"
      },
      "desktop_stats": {
        "photos_printed_caption": "Photos printed"
      }
    },
    "my_orders": {
      "active_orders": "Active Orders",
      "completed_orders": "Completed Orders",
      "no_orders_button": "Pick Some Photos",
      "no_orders_title": "Seems like you haven't made any orders yet.",
      "resend_email": "Resend Email",
      "verify_email": "Verify your email"
    },
    "new_email_capture": {
      "a_box_of_mixtiles": {
        "subtitle": "I'll upload photos myself",
        "title": "A box of Mixtiles",
        "tiles_or_book": "Tiles or a Photo Book"
      },
      "agree_to_emails": "I agree to receive information and promotional communications",
      "agree_to_emails_sign_now": "Sign up to receive exclusive offers, get inspired, and discover our new products",
      "attribution": {
        "channels": {
          "email": "Email",
          "facebook": "Facebook",
          "flyer": "Flyer",
          "friend": "Friend",
          "game": "Mobile Game",
          "google": "Google",
          "instagram": "Instagram",
          "other": "Other",
          "pinterest": "Pinterest",
          "podcast": "Podcast",
          "airport": "Airport",
          "shorts": "Shorts",
          "snapchat": "Snapchat",
          "stacey_solomon": "Stacey Solomon",
          "rebecca_judd": "Rebecca Judd",
          "tammin_sursok": "Tammin Sursok",
          "tia_mowry": "Tia Mowry",
          "tiktok": "TikTok",
          "tv": "TV",
          "twitter": "Twitter",
          "youtube": "Youtube"
        },
        "help_us_improve": "Help Us Improve!",
        "sub_options": {
          "influencer": "An influencer",
          "not_sure": "I'm not sure",
          "paid_ad": "A paid ad"
        },
        "title": "Where did you hear about Mixtiles?"
      },
      "continue": "Continue",
      "disagree_to_emails": {
        "emphasized": "do not",
        "text": "Tick this box if you {{emphasized}} want to receive marketing communications from us"
      },
      "email_placeholder": "What's your email?",
      "for_gift": "For someone else",
      "for_gift_subtitle": "I'm buying a gift",
      "for_me": "For myself",
      "for_me_subtitle": "I'm decorating my home",
      "gift_card": {
        "subtitle": "I'll let them choose their own photos",
        "title": "Gift card"
      },
      "gift_question": "What type of gift?",
      "intro": {
        "title": "Let's get you started with Mixtiles"
      },
      "lets_create": "Let's create an amazing gift",
      "name_placeholder": "What's your name?",
      "privacy_disclaimer": "By continuing, you indicate that you have read and agree to our {{v1}} & {{v2}}",
      "sms_step_label": "What's your number?",
      "sms_step_title": "Get exclusive sales & offers to your phone",
      "sms_privacy_disclaimer": "By entering your phone number, you agree to receive marketing messages at the number provided. Consent is not a condition of purchase. Message and data rates may apply. Message frequency varies. Reply HELP for help or STOP to cancel. View our {{v1}} and {{v2}} ",
      "sms_privacy_disclaimer_consent": "By entering your phone number, you agree to receive marketing text and messaging-app updates, in accordance with our Privacy Policy. You can unsubscribe at any time by replying STOP or clicking the opt-out link as applicable.",
      "title": "Hey there, {{v1}}!",
      "title_no_name": "Hey there!",
      "who_for": "Who's it for?"
    },
    "order": {
      "add_photos": "Add Photos",
      "add_photos_count": "Add {{v1}} Photos",
      "add_photos_single": "Add 1 Photo",
      "add_to_bag": "Add to Bag",
      "art": "Art",
      "art_orientation_warning": {
        "checkout": {
          "label": {
            "singular": "Art looks best in vertical."
          }
        }
      },
      "checkout": {
        "add_address": "Add Address",
        "add_gift_note": "Add Gift Note",
        "add_gift_note_options": {
          "close": "Close",
          "description": "We'll add this note to your package (and won't include a receipt)",
          "edit_note": "Edit or Remove Note",
          "edit_options": {
            "dismiss": "Dismiss",
            "edit": "Edit Text",
            "remove": "Remove Gift Note"
          },
          "header": "Add a Gift Note",
          "placeholder": "Hey, I hope you love these moments as much as I do. Hugs, Me",
          "start_writing": "Start Writing"
        },
        "add_payment": "Add Payment Method",
        "add_payment_options": {
          "credit_card_ends_with": "Ending in {{v1}}",
          "paying_with": "Paying with {{v1}}"
        },
        "are_you_sure": "Are you sure?",
        "change_info": "Change",
        "confirm_button_text_gdpr": "Confirm & Pay",
        "confirm_button_text_non_gdpr": "Place Order",
        "tokushoho_disclaimer": "返品・キャンセル条件／特定商取引法に基づく表記",
        "gift_card_available_credits": "{{v1}} available",
        "gift_card_credits": "Gift Card Credits",
        "gift_card_remove_title": "Are you sure you want to remove your gift card?",
        "gift_note_added": "Gift Note Added",
        "minimum_order_fee": {
          "description": [
            "The minimum order size is {{v1}},",
            " unfortunately we have to charge the difference"
          ],
          "title": "Minimum order fee"
        },
        "no_go_back": "No, go back",
        "payment_errors": {
          "add_new_card": "Add New Card",
          "authentication_failed_text": "Sorry, we couldn't authenticate your card. Please add a new card and try again.",
          "authentication_failed_title": "Authentication Failed",
          "card_declined_text": "Sorry, we got a decline on your card. Please try again with a different card.",
          "card_declined_text_1": "Your card was declined. Please check your card details.",
          "card_declined_text_2": "If everything looks correct, contact your bank and try again.",
          "card_declined_title_2": "Card Declined",
          "charge_failed_text": "Sorry, we couldn't charge you for this order. Please add a new credit card and try again.",
          "charge_failed_title": "Charge Failed",
          "incomplete_photo_wall": {
            "missing_photos_plural": "Your photo wall is missing {{v1}} photos",
            "missing_photos_singular": "Your photo wall is missing 1 photo"
          },
          "invalid_email_text": "Please re-enter your email address so we can complete your order.",
          "invalid_email_title": "Please enter your email",
          "no_charge_text": "Don't worry, you haven't been charged",
          "no_tiles_selected": "No Tiles Selected!",
          "oops_order_failed": "Oops, Order Failed",
          "order_price_calculation": {
            "subtitle": "Please refresh the page. Don't worry, your photos will be saved.",
            "title": [
              "Sorry, we had a problem",
              "calculating the price"
            ]
          },
          "order_error_text": "We're sorry, we couldn't complete your order. You can try again, or talk to us!",
          "order_error_title": "Order failed",
          "payment_error_text": "We're sorry, we couldn't complete your order because of a payment error. You can try again, or talk to us!",
          "payment_error_title": "Payment failed",
          "uploads_failed_text": "We had problems processing some of your photos. Try uploading them again."
        },
        "payment_methods": "Payment Methods",
        "payment_summary_rows": {
          "add_many_more_to_get_discount": "Add {{v1}} tiles to get {{v2}}% off your entire order",
          "add_more_to": {
            "get_more_many": "Add {{v1}} tiles to get {{v2}} for free!",
            "get_more_one": "Add {{v1}} tiles to get 1 tile for free!"
          },
          "add_one_more_to_get_discount": "Add one tile to get {{v1}}% off your entire order",
          "add_one_to": {
            "get_more_many": "Add 1 tile to get {{v2}} for free!",
            "get_more_one": "Add 1 tile to get 1 tile for free!"
          },
          "are_free": "{{v1}} of which are free",
          "base_price_many": "{{v1}} tiles, {{v2}} each",
          "bundle_action": {
            "add_another_many": "add {{v1}} for another discount!",
            "add_another_one": "add 1 for another discount!",
            "add_many": "add {{v1}} tiles to get the discount!",
            "add_many_short": "add {{v1}} tiles to get the discount!",
            "add_one": "add 1 tile to get the discount!",
            "add_one_short": "add 1 tile to get the discount!",
            "get_next_bundle": "get {{v1}} for {{v2}}",
            "perfect": "Perfect! You saved {{v1}}."
          },
          "bundle_change_to_size": "Change size to {{v1}} to use promo code",
          "buy_over_percent_off_orders": "{{v1}}% off orders",
          "buy_over_percent_off_orders_over_price": "{{v1}}% off orders above {{v2}}",
          "buy_over_price_applied": "Yay! You're saving {{v1}}%",
          "buy_over_price_applied_saved": "Yay! You're saving {{v1}}",
          "discount_percentage_literal": "You're saving {{v1}}%",
          "buy_over_price_buy_more": "add {{v1}} to get the discount",
          "buy_over_price_buy_more_short": "add {{v1}} to get the discount",
          "buy_over_tier": "{{v1}}% off {{v2}}+",
          "buy_over_tiers_pair": "{{v1}} • {{v2}}",
          "buy_x_get_y": "Buy {{v1}} Get {{v2}}",
          "buy_x_get_y_action": {
            "get_more_many": "You can add {{v1}} more free tiles.",
            "get_more_one": "You can add 1 more free tile.",
            "saved": "Yay, you saved {{v1}}!",
            "yay_get_many": "Yay, your next {{v1}} tiles are free!",
            "yay_get_one": "Yay, your next tile is free!"
          },
          "can_add_free_tiles": "You can add {{v1}} free tiles!",
          "can_add_one_free_tile": "You can add one free tile!",
          "canvas_tile": "1 canvas tile",
          "canvas_tiles": "{{v1}} canvas tiles",
          "color_tiles": "{{v1}} {{color}} tiles",
          "creditUsed": "Credit",
          "delivery_by": "Delivery by",
          "discount": "Discount",
          "discount_off_over_price": "{{v1}}% off over {{v2}}",
          "discount_off_over_price_short": "{{v1}}% off over {{v2}}",
          "discount_percentage": "{{v1}}% off",
          "discount_percentage_automatic": "{{v1}}% off photo books",
          "discounts_applied": "{{v1}} applied",
          "eligible_free_shipping": "Eligible for free shipping",
          "eligible_free_shipping_over": "Enjoy free shipping on orders over {{v1}}",
          "free": "Free",
          "free_shipping": "Free shipping",
          "free_shipping_over": "Free shipping over {{v1}}",
          "free_tiles_many": "{{v1}} free tiles",
          "free_tiles_single": "1 free tile",
          "import_fee": "Import Fee",
          "international_taxes": "Local Taxes",
          "is_free": "1 of which is free",
          "all_free": "free",
          "many_tiles": "{{v1}} tiles",
          "many_books": "{{v1}} books,{{v2}}",
          "mixed_frames": "mixed frames",
          "mixed_sizes_and_frames": "mixed sizes & frames",
          "more_tiles_many": "{{v1}} more tiles",
          "more_tiles_one": "1 more tile",
          "more_tiles_with_each_price": "{{v1}} more tiles, {{v2}} each",
          "one_color_tile": "1 {{color}} tile",
          "one_tile": "1 tile",
          "photo_book_description_plural": "Photo Books ({{v1}} pages)",
          "photo_book_description_singular": "Photo Book ({{v1}} pages)",
          "sales_tax": "Sales Tax",
          "select_more_tiles_many": "Select {{v1}} more tiles",
          "select_more_tiles_one": "Select one more tile",
          "select_some_tiles": "Add some tiles",
          "shipping": "Shipping",
          "subtotal": "Subtotal",
          "tax": "Tax",
          "tiles_count": "{{v1}} tiles",
          "tiles_size_many": "{{v1}} tiles for {{v2}}",
          "total": "Total",
          "wall_sign": "wall sign",
          "wall_signs": "wall signs",
          "wide_frame_tile": "1 {{color}} wide frame tile",
          "wide_frame_tiles": "{{v1}} {{color}} wide frame tiles",
          "will_be_free_many": "{{v1}} will be free!",
          "will_be_free_one": "one will be free!"
        },
        "promo": {
          "cancel": "Cancel Promo Code",
          "free_tiles": "Free tiles",
          "free_books": "Free books",
          "title": "Promo",
          "yes_remove": "Yes, remove code"
        },
        "shipping_options": {
          "calculating_delivery_date": "Calculating delivery date...",
          "delivery_by": "By {{v1}}",
          "estimated_delivery": "Est. {{v1}}",
          "express_new_version": "Express Shipping - {{v1}}",
          "express_name": "Express Shipping",
          "priority": "Priority Shipping - {{v1}}",
          "priority_name": "Priority Shipping",
          "standard": "Standard Shipping"
        }
      },
      "add_product": "Add Product",
      "canada_tariff_notice_bag": "Canvas prints & photo books are tariff-free",
      "canada_tariff_notice_tiles": "Canvas prints are tariff-free",
      "cart_title": "My Bag",
      "cart_volume_discount": "VOLUME DISCOUNT",
      "cart_add_promo": "Add promo",
      "cart_change_promo": "Change promo",
      "cart_free_shipping_applied": "Free shipping applied",
      "cart_bag": "Bag",
      "empty_bag_title": "Your bag is empty",
      "empty_bag_cta": "Shop Now",
      "cart_edit": "Edit",
      "cart_header": {
        "photo_book": "Photo Book",
        "tiles_one": "1 Tile",
        "tiles_other": "{{count}} Tiles"
      },
      "cart_summary": {
        "tiles_one": "{{count}} Tile",
        "tiles_other": "{{count}} Tiles",
        "wall_signs_one": "{{count}} Wall Sign",
        "wall_signs_other": "{{count}} Wall Signs",
        "with_size": "{{item}}, {{size}}",
        "frame_breakdown_row_one": "{{count}} {{frame}} Tile, {{size}}",
        "frame_breakdown_row_many": "{{count}} {{frame}} Tiles, {{size}}",
        "canvas_breakdown_row": "{{count}} {{frame}}, {{size}}",
        "frame_tiles_one": "{{count}} {{frame}} Tile",
        "frame_tiles_many": "{{count}} {{frame}} Tiles",
        "canvas_tiles": "{{count}} {{frame}}",
        "combined_no_size": "{{tiles}} & {{signs}}",
        "mixed_sizes_lower": "mixed sizes",
        "mixed_frames": "mixed frames",
        "photo_book": "Photo Book, {{size}}",
        "book_with_pages": "Book, {{size}}, {{pageCount}} pages"
      },
      "remove_item_popup": {
        "title": "Are you sure you want to remove it?",
        "tiles": "This will delete the tiles you created",
        "photo_book": "This will delete the photo book you created",
        "delete": "Delete"
      },
      "checkout_button_text": "Checkout",
      "choose_from_phone": "Choose from Phone",
      "done": {
        "confirmation_email": "You'll get a confirmation email in a few minutes",
        "delivery_time": "You'll get your order by {{v1}}",
        "next": "Next",
        "please_hold": "Ok, great. Please hold while we complete your order.",
        "will_receive_email": "You will receive an email confirmation shortly at",
        "woohoo": "Woohoo, all done!"
      },
      "faces_cropped_warning": {
        "cart_cta": "Review & Fix",
        "cart_label": "Face cropped out.",
        "cta": {
          "change_size": "Change Size",
          "crop": "Fix Crop"
        },
        "label": "Some faces are cropped out.",
        "notification": {
          "change_size": {
            "cta": "Undo",
            "title": "Tile changed to {{size}}"
          },
          "crop": {
            "cta": "Undo",
            "title": "Tile crop changed"
          }
        }
      },
      "filters": {
        "b_n_w": "B&W",
        "b_n_w2": "B&W2",
        "dramatic": "Dramatic",
        "noir": "Noir",
        "none": "None",
        "original": "Original",
        "painting": "Painting",
        "painting2": "Painting 2",
        "pencil": "Pencil",
        "pencil2": "Pencil 2",
        "silver": "Silver",
        "sketch": "Sketch",
        "sketch2": "Sketch 2",
        "vivid": "Vivid",
        "vivid2": "Vivid 2",
        "winter": "Winter"
      },
      "frame_colors": {
        "black": "Black",
        "none": "Frameless",
        "red_ash_wood": "Walnut",
        "white": "White",
        "wood": "Oak"
      },
      "frame_presets": {
        "earthy_blend": "Earthy Blend",
        "classic_blend": "Classic Blend",
        "harmony_mix": "Harmony Mix"
      },
      "import_from_google_photos": "Import from Google Photos",
      "incomplete_collage_warning": {
        "label": "Collage is missing photos."
      },
      "ai_tile_generating_warning": {
        "label": "Your new style is still being created.",
        "cta": "View",
        "popup_subtitle": "You can check out as soon as it's ready."
      },
      "list_discount": {
        "banner": "Presidents' Day: {{v1}}% Off Photo Books"
      },
      "low_quality_warning": {
        "action_keep": "Keep Anyway",
        "action_remove": "Remove From Order",
        "banner": {
          "cta": "Approve photos",
          "text": "These photos are below the recommended resolution, they might look blurry in print",
          "title": "Review Low Resolution Photos"
        },
        "text": "This photo is actually pretty small. It will probably make a blurry tile!",
        "title": "Low Image Quality",
        "warning": {
          "cta": "Replace",
          "cta_try_in_size": "Try in {{sizeName}}",
          "label": "Low resolution photo."
        }
      },
      "materials": {
        "canvas": "Canvas",
        "classic": "Classic Frame",
        "frameless": "Frameless",
        "sticker": "Sticker",
        "wide_frame": "Wide Frame"
      },
      "materials_detailed_descriptions": {
        "canvas": "Premium canvas for an elevated look. Printed on stretched cotton, with easy magnetic mounting.",
        "classic": "A classic and premium look. Printed on superior paper, with easy magnetic mounting.",
        "frameless": "A minimalist and modern design. Printed on superior paper, with easy magnetic mounting.",
        "wide_frame": "Bold elegance for a premium look. Printed on superior paper, with easy magnetic mounting."
      },
      "materials_plural": {
        "classic": "Classic Frames",
        "wide_frame": "Wide Frames"
      },
      "mats": {
        "deep": "Deep",
        "heart": "Heart",
        "medium": "Medium",
        "none": "None",
        "round": "Round",
        "shallow": "Shallow"
      },
      "promo_code_errors": {
        "messages": {
          "already_a_user": "It looks like this promo code is only for first-time customers. Sorry!",
          "already_registered": "This code has already been registered",
          "default": "It looks like that code does not exist. Sorry!",
          "expired": "It looks like this code has already expired. Sorry!",
          "non_existing": "It looks like this code doesn't exist. Sorry!",
          "quantity_exceeded": "This code has already been entered! No need to enter it again. Simply go back to the device where you first entered the code, head to checkout, and your free tiles will be ready",
          "redemptions_per_customer_exceeded": "Oops, it looks like this code has already been used and isn't valid anymore. Sorry!",
          "self_referral": "This code is for friends you refer to Mixtiles.",
          "server_error": "We had an issue verifying your code. Please try again or contact us."
        },
        "titles": {
          "gift_card_empty": "This gift card has been fully redeemed",
          "gift_card_inactive": "This gift card is not active"
        }
      },
      "styles": {
        "mixed_styles": "Mix"
      },
      "tile_actions": {
        "adjust": "Adjust Crop",
        "remove": "Remove",
        "remove_photo": "Remove Photo",
        "replace": "Replace Photo",
        "replace2": "Replace",
        "replace_subtitle": "Pick from your current photos or upload a new one"
      },
      "upload_failed": {
        "action_continue": "Continue",
        "format_not_supported": "Some files aren't supported. Please convert them to JPG or PNG.",
        "text": "We had issues uploading your photo. Please try again or choose another photo.",
        "title": "Upload Failed"
      },
      "upload_photo": "Upload Photo",
      "upload_photos": "Upload Photos",
      "what_to_add": "What do you want to add?"
    },
    "cart_upsells": {
      "bath_time": {
        "card_title_dog": "Turn your dog into funny bath art!",
        "card_title_cat": "Turn your cat into funny bath art!",
        "card_cta": "View Now",
        "flow_title": "Bath Time"
      },
      "card_dismiss": "Dismiss",
      "wall_subtitle_one": "{{count}} tile, {{size}}",
      "wall_subtitle_other": "{{count}} tiles, {{size}}",
      "add_tiles_one": "Add {{count}} Tile",
      "add_tiles_other": "Add {{count}} Tiles",
      "select_tiles_to_add": "Select tiles to add",
      "select_tiles_to_continue": "Select tiles to continue",
      "wall_tile": "Tile {{position}}"
    },
    "order_management": {
      "actions": {
        "change_address": "Change Address",
        "edit_order": "Edit Order",
        "duplicate_order": "Duplicate Order",
        "tracking_details": {
          "base": "Tracking Details",
          "not_shipped_suffix": "once shipped"
        },
        "edit_order_dialog": {
          "title": "Cancel & Edit?",
          "subtitle": "Cancel & Edit will stop your order so you can update it.",
          "refund_info": "You'll receive credit of {{v1}} to use at checkout. To get a refund instead, contact support after canceling.",
          "button": "Cancel & Edit Order",
          "go_back": "Keep My Order"
        },
        "view_order_summary": "View Order Summary"
      },
      "already_shipped_dialog": {
        "cancel_text": "This order has already entered manufacturing, so it can no longer be canceled.",
        "cancel_title": "Too Late to Cancel",
        "update_text": "This order has already entered manufacturing, so it can no longer be updated.",
        "update_title": "Too Late to Update",
        "ok": "Got It"
      },
      "got_it": "Got It",
      "modifying_existing_order_dialog": {
        "ok": "Got It",
        "text": "Changes you make might affect the delivery date",
        "title": "Modifying an existing order"
      },
      "order_card": {
        "created_at": "Created at",
        "delivered_at": "Delivered at",
        "expected_arrival": "Expected Arrival",
        "number_of_photo_books": "Number of Photo Books",
        "number_of_tiles": "Number of Tiles",
        "order_number_prefix": "Order"
      },
      "order_processing": {
        "cant_view_file": "Unable to download. Try a different browser"
      },
      "order_processing_dialog": {
        "text": "We're processing your order. Please try again in a few minutes!",
        "title": "Order Processing"
      },
      "statuses2": {
        "approved": "In Production",
        "cancelled": "Cancelled",
        "complete": "Delivered",
        "processing": "Processing...",
        "shipped": "On Its way"
      },
      "title": "Your Order"
    },
    "out_of_stock": {
      "applied_to_other_materials": "Applied to other materials",
      "applied_to_x": "Applied to {{v1}}",
      "applied_where_available": "Applied where available",
      "available_in_other_materials": "Available in other materials",
      "available_in_other_sizes": "Available in other sizes",
      "only_available_for_x": "Only available for {{v1}}",
      "some_tiles_arent_available_for_this_option": "Some tiles aren't available for this option",
      "undo": "Undo",
      "we_changed_some_frame_that_werent_available": "We changed some tiles that weren't available",
      "x_available_in_selected_materials": "{{v1}} available in selected materials",
      "x_isnt_available_in_x": "{{v1}} isn't available in {{v2}}",
      "x_isnt_available_size_changed_to_x_subtitle": [
        "Size changed to {{v1}}"
      ],
      "x_isnt_available_size_changed_to_x_title": [
        "{{v1}} isn't available"
      ],
      "x_only_available_in_x": "{{v1}} only available in {{v2}}",
      "x_x_isnt_available": "{{v1}} {{v2}} isn't available",
      "x_x_isnt_available_color_changed_to_x_subtitle": [
        "Color changed to {{v1}}"
      ],
      "x_x_isnt_available_color_changed_to_x_title": [
        "{{v1}} {{v2}} isn't available"
      ]
    },
    "photo": {
      "edit_tile": "Edit",
      "photo_tiles": "Photo Tiles"
    },
    "photo_book": {
      "product_names": {
        "newborn": "Newborn Photo Book",
        "family": "Family Photo Book",
        "annual": "Annual Photo Book",
        "travel": "Travel Photo Book",
        "wedding": "Wedding Photo Book"
      },
      "add_photos_dialog": {
        "title": "Where should we place your new photos?",
        "add_chronologically": "Add Chronologically",
        "add_at_end": "Add at the end"
      },
      "arrange": {
        "name": "Arrange"
      },
      "arrival_notice": {
        "login_title_one": "Welcome back, {{count}} book restored to your bag",
        "login_title_other": "Welcome back, {{count}} books restored to your bag",
        "title_one": "{{count}} book restored to your bag",
        "title_other": "{{count}} books restored to your bag"
      },
      "low_res_photos": {
        "cart_cta": "Review",
        "cart_label": "Low resolution photos."
      },
      "not_enough_photos": {
        "cart_cta": "Add",
        "cart_label": "Add {{numPhotos}} more photos to finish.",
        "cart_title": "Add more photos to your Photo Book",
        "cta": "Add More Photos",
        "subtitle": "You've uploaded fewer than {{totalAmount}} photos. Please add {{missingAmount}} more to complete your order",
        "title": "Not Enough Photos"
      },
      "too_many_pages": {
        "title": "Almost there! Your book is a little too full",
        "subtitle": "Photo Books can hold up to {{maxPhotos}} photos. Remove {{extraPhotos}} photos to finish your book.",
        "cta": "Edit My Book"
      },
      "photo_deleted": "Photo deleted",
      "photos_not_uploaded": {
        "title": "{{count}} photos didn't finish uploading",
        "subtitle": "Please add them again before checking out"
      },
      "photo_limit": {
        "title": "Photo Limit Reached",
        "message": "Photo Limit Reached. Remove some to add more",
        "subtitle_single": "Please remove 1 photo",
        "subtitle_plural": "Please remove {{v1}} photos",
        "all_set": "All Set! Click '{{done}}' to continue"
      },
      "swipe_pages": "Swipe page",
      "creating_book": "Creating book...",
      "updating_book": "Updating book...",
      "replacing_photo": "Replacing photo...",
      "uploading_photos": "Uploading Photos",
      "empty_book": "The book is empty.",
      "title": "Title",
      "photo": "Photo",
      "added_in_chronological_order": "Added in chronological order",
      "default_cover_text": "Happy Moments",
      "size": "Size",
      "cover": "Cover",
      "pages_disabled_message": "You need more photos to rearrange pages",
      "page_order": {
        "title": "Pages Overview",
        "subtitle": "Drag a photo to rearrange",
        "sort_by_date": "Sort By Date",
        "done": "Done",
        "sort_confirmation": {
          "title": "Sort Book Pages By Date",
          "main_text": "Sort Photos from Earliest to Latest",
          "approve": "Sort",
          "dismiss": "Cancel"
        },
        "snackbar": {
          "pages_sorted": "Pages Sorted",
          "pages_sorted_by_date": "Pages sorted by date",
          "undo": "Undo",
          "cover_back_cant_edit": "The cover's back can't be edited"
        },
        "warning": {
          "missing_date": "Marked photos weren't auto-sorted due to missing date. Please arrange manually"
        }
      },
      "cover_edit": {
        "title": "Edit Cover",
        "title_label": "Title",
        "title_font_label": "Title Font",
        "cover_photo_label": "Cover Photo",
        "designed_covers": "Designed Covers",
        "upload": "Upload",
        "designs": "Designs",
        "select_cover": "Select Cover",
        "crop_and_title_hint": "Pinch to crop, tap title to edit",
        "ai_cover_create": "Create",
        "ai_cover_title": "Your book title",
        "ai_cover_headline_label": "Your book title",
        "ai_cover_headline_placeholder": "Your book title",
        "ai_cover_generate": "Create Cover",
        "ai_cover_retry": "Retry",
        "ai_cover_creating": "Creating Cover",
        "ai_cover_ready_title": "Your cover is ready",
        "ai_cover_ready_action": "Edit cover"
      },
      "cover_deep_link": {
        "rejected_title": "Something went wrong. Please try picking a cover again"
      },
      "deep_link_photos": {
        "rejected_title": "Something went wrong. Please add your photos to start the book"
      },
      "add_text": "Caption",
      "size_selection": {
        "title": "Select Book Size",
        "select_size": "Select size",
        "page_count": "Page Count",
        "tier_page_range": "{{start}} - {{end}} pages",
        "current_tier": "Current tier"
      },
      "page_controls": {
        "replace_photo": "Replace",
        "delete_photo": "Delete",
        "adjust_crop": "Pinch to adjust crop",
        "caption_too_long": "Caption is too long"
      },
      "page_1": "Page 1",
      "page_single": "Page {{page}}",
      "page_range": "Page {{start}}-{{end}}",
      "turn_pages": "Turn Pages",
      "ios_uploader": {
        "old_ux_message": "Once you press 'Add', give it 30 seconds to load the photos",
        "old_ux_upload": "Upload Photos"
      }
    },
    "pitch": {
      "copyright": "© Copyright 2015-{{v1}} Mixtiles, LTD",
      "footer": {
        "about": "About",
        "accessibility": "Accessibility Statement",
        "blog": "Our Blog",
        "canvas_prints": "Canvas Prints",
        "careers": "Careers",
        "facebook": "Facebook",
        "follow_us": "Follow Us",
        "gallery_walls": "Gallery Walls",
        "impressum": "Impressum",
        "instagram": "Instagram",
        "join_us": "Join Mixtiles Engineering",
        "privacy": "Privacy Policy",
        "cookie_policy": "Cookie Policy",
        "products": "Products",
        "resources": "Resources",
        "terms_of_use": "Terms of Use",
        "twitter": "Twitter",
        "tokushoho": "特定商取引法に基づく表記"
      },
      "footer_links": {
        "accessibility_statement": "ACCESSIBILITY STATEMENT",
        "impressum": "IMPRESSUM",
        "privacy_policy": "PRIVACY POLICY",
        "cookie_policy": "COOKIE POLICY",
        "terms_of_use": "TERMS OF USE"
      },
      "global_shipping": "Global shipping, fast delivery",
      "headline": "Turn your photos into affordable, stunning wall art",
      "icons": {
        "satisfaction": {
          "text": "Not satisfied? Get a full refund",
          "title": "Satisfaction guaranteed"
        }
      },
      "main_button_cta": "Let's Go"
    },
    "product_selection": {
      "photo_books_name": "Photo Books",
      "tiles_name": "Tiles",
      "title_choose_what_to_create": "Choose what to create"
    },
    "rating": {
      "back_to_mixtiles": "Back to Mixtiles",
      "comment": {
        "1-2-stars": {
          "sentence": "We're sorry! Care to tell us what went wrong?"
        },
        "3-4-stars": {
          "question": "How can we improve?",
          "sentence": "We want to do better!"
        },
        "5-stars": {
          "question": "What did you especially like?",
          "sentence": "We're glad to hear!"
        }
      },
      "contact_us": "contact us",
      "feel_free": "If there is anything we can help with, feel free to",
      "first_question": "How was your online shopping experience with Mixtiles?",
      "next": "Next",
      "star_caption": {
        "1": "terrible",
        "2": "bad",
        "3": "ok",
        "4": "good",
        "5": "excellent"
      },
      "submit": "Submit",
      "tell_us_here": "Tell us here... (Optional)",
      "thanks": "Thanks for your feedback!"
    },
    "refresher_kit_request": {
      "back": "Back",
      "back_to_homepage": "Back to Homepage",
      "confirmation": {
        "received_title": "We’ve received your request!"
      },
      "contact_support": "Contact Support",
      "continue": "Continue",
      "continue_with_count": "Continue ({{count}})",
      "errors": {
        "invalid_email": "Please enter a valid email address",
        "invalid_state": "Please enter a valid state",
        "invalid_submission": "We couldn’t accept this request. Please check your selection and details and try again.",
        "load_failed": "Oops, looks like something went wrong.",
        "required": "Required",
        "submit_failed": "We couldn’t send your request. Please try again."
      },
      "expired": {
        "body": "Contact our support team and we’ll send you a new one.",
        "title": "This link has expired"
      },
      "frame_name": "{{v1}} Frame",
      "inactive": {
        "body": "Contact our support team and we’ll help you get everything sorted.",
        "title": "This link is no longer active"
      },
      "invalid_link": {
        "body": "Contact our support team and we’ll help you get everything sorted.",
        "title": "This link isn’t valid"
      },
      "no_orders": {
        "body": "Contact our support team and we’ll help you get everything sorted.",
        "title": "We couldn’t find any delivered orders on this account"
      },
      "select": {
        "title": "Select the tiles that need a refresh and get replacement adhesives"
      },
      "selected_badge": "{{v1}} selected",
      "selected_of_tiles": "{{v1}}/{{v2}} Tiles",
      "sending": "Sending your request...",
      "shipping": {
        "country": "Country",
        "email": "Email",
        "submit": "Send me a kit",
        "subtitle": "Your replacement adhesives are sent at no cost to you.",
        "title": "Where should we send it?"
      },
      "summary": {
        "adhesives_many": "{{v1}} Replacement adhesives",
        "adhesives_one": "1 Replacement adhesive",
        "title": "Order summary ({{v1}})"
      },
      "switch_account": "Switch Account",
      "tile_count_many": "{{v1}} Tiles",
      "tile_count_one": "1 Tile",
      "try_again": "Try Again",
      "wrong_account": {
        "body": "Log in with the account this link was sent to, or contact our support team.",
        "title": "This link belongs to a different account"
      }
    },
    "referral": {
      "already_referred": "A gift card was already sent to this recipient. Please enter a different email address.",
      "general_error": "An error occurred while sending the gift card. Please try again later.",
      "login": "Login to Continue",
      "menu_title": "Referral Program",
      "referral_sent": "<div>The gift card is on its way to <b>{{v1}}</b>!<br> After their purchase, you will receive <b>{{v2}}</b> in credits and notified by email.</div>",
      "self_referral": "You cannot send a referral gift card to yourself. Please enter a different email address.",
      "send": "Send Now",
      "subtitle": "For every friend that makes a purchase, you'll get {{v1}} in credits - it's free!",
      "title": "Give {{v1}}, Get {{v1}}"
    },
    "size_selection": {
      "price_per_tile": "{{v1}} per tile"
    },
    "wall_designer": {
      "highlighted_tile": {
        "edit_tile": "Edit Tile",
        "swap_position": "Swap Position",
        "swap_position_title": "Choose a photo to swap with"
      },
      "photos_selector": {
        "selected": "selected",
        "title": "Select {{v1}} photos"
      },
      "preferences_saved": {
        "cta": "Return to Homepage",
        "subtitle": "We hope to see you soon for more exciting products and offers",
        "title": "Your preferences have been updated"
      },
      "zoom_button": {
        "full_view": "Full View",
        "zoom": "Zoom"
      }
    },
    "wall_feed": {
      "categories": {
        "large": "Large",
        "medium": "Medium",
        "small": "Small"
      }
    },
    "product": {
      "carousel": {
        "peel_stick": "Just peel and stick",
        "adjust_to_perfection": "Adjust to perfection",
        "no_damage": "Leaves no marks"
      }
    },
    "product_page": {
      "reviews_count": "with over 100k App Store ratings",
      "tile_product": {
        "title": {
          "regular": "Restickable Photo Tiles",
          "canvas": "Peel & Stick Canvas Prints"
        },
        "tile": "Tile",
        "description": "Printed framed pictures that stick to any wall, leave no damage, and can be moved around.",
        "description_mobile": {
          "no_nails": "No nails needed, sticky to any wall",
          "satisfaction": "Satisfaction guaranteed"
        }
      },
      "art_product": {
        "description": "Wall art that sticks to any wall, leaves no damage, and can be moved around.",
        "description_mobile": {
          "no_nails": "No nails needed, sticky to any wall",
          "satisfaction": "Satisfaction guaranteed"
        }
      },
      "photobook_product": {
        "title": {
          "default": "Photo Books Made Easy"
        },
        "description": "Design your book with just a few taps, and see it come to life in 3D.",
        "bullet_points": {
          "same_price": "Same price, no matter how many pages",
          "simple_pricing": "Simple pricing, no surprises",
          "no_hidden_fees": "No hidden fees",
          "free_shipping": "Free shipping"
        },
        "description_mobile": {
          "fixed_price": "Fixed price, no matter how many pages",
          "quality_book": "Museum-quality prints, hardcover book",
          "free_shipping": "Free shipping"
        },
        "beauty": {
          "title": "Beauty in Every Page",
          "subtitle": "Every book comes with a hard, matte cover and is printed on premium pages with a silk finish"
        }
      },
      "reviews_count_mobile": "100k+ ratings",
      "price_each": "/each",
      "choose_your_own_style": "Choose your own style",
      "controls": {
        "frame_style": "Frame Style",
        "frame_size": "Frame Size",
        "tile": {
          "start": "Start Creating"
        },
        "art": {
          "start": "Add Artwork",
          "browse": "Browse Art"
        },
        "photobook": {
          "start": "Shop Now"
        }
      },
      "magnetic_hanging": {
        "title": "Meet magnetic hanging",
        "description": "Perfectly align, adjust, and reposition your tiles with ease. Enjoy damage-free walls and the freedom to refresh your space anytime."
      },
      "community": {
        "title": "From our community",
        "description": "This is what our customers have to say about us",
        "load_more": "Load More"
      },
      "explore": {
        "photo_tiles": "Explore Photo Tiles",
        "canvas_prints": "Explore Canvas Prints",
        "art": "Explore Art",
        "photo_books": "Explore Photo Books"
      }
    },
    "tile_upsell": {
      "title": "Order Complete!",
      "centerpiece": {
        "title": "Add a custom sign to your wall",
        "subtitle": "Only {{price}}",
        "button": "Customize Now"
      },
      "collage": {
        "title": "A collage of your photos could be a great gift",
        "subtitle": "{{size}} for {{price}}",
        "button": "Customize Now"
      },
      "referral": {
        "title": "Have friends who'd love Mixtiles?",
        "subtitle": "This links gives them ${{price}} off",
        "button": "Share link"
      }
    },
    "cancel_order_v2": {
      "cta": "Cancel Order",
      "dialog": {
        "title": "Cancel Order",
        "refund_content": "You'll receive a full refund of {{sum}}.",
        "refund_refund_info": "The refund will be applied to your original payment method.",
        "dismiss": "Keep my order"
      }
    },
    "seo": {
      "art": {
        "base": {
          "title": "Artwork by Mixtiles",
          "description": "Turn your photos into affordable, stunning wall art"
        }
      },
      "canvas": {
        "base": {
          "title": "Canvas Prints By Mixtiles",
          "h1": "Custom Canvas Photo Prints",
          "description": "Turn your personal photos into stunning photo tiles that you can hang anywhere — without using nails!"
        },
        "sized": {
          "title": "{{size}} Canvas Prints By Mixtiles",
          "h1": "{{size}} Canvas Prints",
          "description": "Transform your photos into beautiful {{size}} canvas prints — no nails, no damage, just easy wall art."
        }
      },
      "phototiles": {
        "base": {
          "title": "Restickable Photo Tiles By Mixtiles",
          "h1": "Restickable Photo Tiles",
          "description": "Turn you photos into stunning canvas prints without nails or damage to the wall with Mixtiles."
        },
        "sized": {
          "title": "{{size}} Photo Tiles By Mixtiles",
          "h1": "{{size}} Photo Tiles",
          "description": "Turn your pictures into elegant {{size}} photo tiles that stick to walls without nails or tools."
        },
        "withMaterial": {
          "title": "{{size}} {{frameDisplay}} Photo Tiles By Mixtiles",
          "h1": "{{size}} {{frameDisplay}} Photo Tiles",
          "description": "Turn your pictures into elegant {{size}} {{frameDisplayLower}} photo tiles that stick to walls without nails or tools."
        }
      },
      "photobooks": {
        "base": {
          "title": "Photo Books By Mixtiles",
          "h1": "Photo Books",
          "description": "Create beautiful photo books with Mixtiles. Turn your memories into stunning keepsakes that last a lifetime."
        },
        "sized": {
          "title": "Photo Book {{size}} By Mixtiles",
          "h1": "Photo Book {{size}}",
          "description": "{{description}}"
        },
        "wedding": {
          "title": "Wedding Photo Books By Mixtiles",
          "h1": "Wedding Photo Books",
          "description": "Celebrate your love story with wedding photo books by Mixtiles. Create beautiful albums, relive precious moments, and enjoy quality that lasts a lifetime.",
          "sized": {
            "title": "Wedding Photo Book {{size}} By Mixtiles",
            "h1": "Wedding Photo Book {{size}}"
          }
        },
        "memory": {
          "title": "Photo Memory Book By Mixtiles",
          "h1": "Photo Memory Book",
          "description": "Turn your favorite memories into a beautiful Photo Memory Book by Mixtiles. Relive every moment in stunning detail!",
          "sized": {
            "title": "Photo Memory Book {{size}} By Mixtiles",
            "h1": "Photo Memory Book {{size}}"
          }
        },
        "small": {
          "title": "Small Photo Book By Mixtiles",
          "h1": "Small Photo Book",
          "description": "Show off life's best little moments with a Small Photo Book by Mixtiles. Big memories, compact and beautiful.",
          "sized": {
            "title": "Small Photo Book {{size}} By Mixtiles",
            "h1": "Small Photo Book {{size}}"
          }
        },
        "boudoir": {
          "title": "Boudoir Photo Book By Mixtiles",
          "h1": "Boudoir Photo Book",
          "description": "Celebrate confidence with a Boudoir Photo Book by Mixtiles. A bold, beautiful keepsake made just for you.",
          "sized": {
            "title": "Boudoir Photo Book {{size}} By Mixtiles",
            "h1": "Boudoir Photo Book {{size}}"
          }
        },
        "travel": {
          "title": "Travel Photo Book By Mixtiles",
          "h1": "Travel Photo Book",
          "description": "Showcase adventures with a travel photo book by Mixtiles. Capture your journeys, relive every trip, and keep travel memories close at hand.",
          "sized": {
            "title": "Travel Photo Book {{size}} By Mixtiles",
            "h1": "Travel Photo Book {{size}}"
          }
        },
        "coffee-table": {
          "title": "Coffee Table Photo Book By Mixtiles",
          "h1": "Coffee Table Photo Book",
          "description": "Add personality to your decor with a Coffee Table Photo Book by Mixtiles. Style and memories in one perfect piece.",
          "sized": {
            "title": "Coffee Table Photo Book {{size}} By Mixtiles",
            "h1": "Coffee Table Photo Book {{size}}"
          }
        },
        "engagement": {
          "title": "Engagement Photo Book By Mixtiles",
          "h1": "Engagement Photo Book",
          "description": "Capture your love story with an Engagement Photo Book by Mixtiles. A keepsake you'll cherish forever.",
          "sized": {
            "title": "Engagement Photo Book {{size}} By Mixtiles",
            "h1": "Engagement Photo Book {{size}}"
          }
        },
        "family": {
          "title": "Family Photo Book By Mixtiles",
          "h1": "Family Photo Book",
          "description": "Celebrate family milestones with a Family Photo Book by Mixtiles. Memories you'll love sharing again and again.",
          "sized": {
            "title": "Family Photo Book {{size}} By Mixtiles",
            "h1": "Family Photo Book {{size}}"
          }
        },
        "anniversary": {
          "title": "Anniversary Photo Book By Mixtiles",
          "h1": "Anniversary Photo Book",
          "description": "Honor your love story with an Anniversary Photo Book by Mixtiles. Celebrate years of memories beautifully.",
          "sized": {
            "title": "Anniversary Photo Book {{size}} By Mixtiles",
            "h1": "Anniversary Photo Book {{size}}"
          }
        },
        "pet-dog": {
          "title": "Dog Photo Album By Mixtiles",
          "h1": "Dog Photo Album",
          "description": "Celebrate your furry best friend with a Dog Photo Album by Mixtiles. Every wag, captured forever.",
          "sized": {
            "title": "Dog Photo Album {{size}} By Mixtiles",
            "h1": "Dog Photo Album {{size}}"
          }
        },
        "mothers-day": {
          "title": "Mother's Day Photo Book By Mixtiles",
          "h1": "Mother's Day Photo Book",
          "description": "Give Mom the ultimate keepsake with a Mother's Day Photo Book by Mixtiles. Filled with love, laughter, and memories.",
          "sized": {
            "title": "Mother's Day Photo Book {{size}} By Mixtiles",
            "h1": "Mother's Day Photo Book {{size}}"
          }
        },
        "christmas": {
          "title": "Christmas Photo Book By Mixtiles",
          "h1": "Christmas Photo Book",
          "description": "Share the holiday magic with a Christmas Photo Book by Mixtiles. A gift they'll cherish year after year.",
          "sized": {
            "title": "Christmas Photo Book {{size}} By Mixtiles",
            "h1": "Christmas Photo Book {{size}}"
          }
        },
        "fathers-day": {
          "title": "Father's Day Photo Book By Mixtiles",
          "h1": "Father's Day Photo Book",
          "description": "Show Dad he's your hero with a Father's Day Photo Book by Mixtiles. Stories he'll treasure forever.",
          "sized": {
            "title": "Father's Day Photo Book {{size}} By Mixtiles",
            "h1": "Father's Day Photo Book {{size}}"
          }
        },
        "retirement": {
          "title": "Retirement Photo Book By Mixtiles",
          "h1": "Retirement Photo Book",
          "description": "Celebrate new beginnings with a Retirement Photo Book by Mixtiles. Memories of hard work and well-earned rest.",
          "sized": {
            "title": "Retirement Photo Book {{size}} By Mixtiles",
            "h1": "Retirement Photo Book {{size}}"
          }
        },
        "birthday": {
          "title": "Birthday Photo Book By Mixtiles",
          "h1": "Birthday Photo Book",
          "description": "Turn birthday memories into lasting treasures with a Birthday Photo Book by Mixtiles. Every year deserves a page!",
          "sized": {
            "title": "Birthday Photo Book {{size}} By Mixtiles",
            "h1": "Birthday Photo Book {{size}}"
          }
        },
        "graduation": {
          "title": "Graduation Photo Book By Mixtiles",
          "h1": "Graduation Photo Book",
          "description": "Mark this milestone with a Graduation Photo Book by Mixtiles. Capture all the moments that made the journey worthwhile.",
          "sized": {
            "title": "Graduation Photo Book {{size}} By Mixtiles",
            "h1": "Graduation Photo Book {{size}}"
          }
        },
        "yearly": {
          "title": "Yearly Photo Book By Mixtiles",
          "h1": "Yearly Photo Book",
          "description": "Tell the story of your year with a Yearly Photo Book by Mixtiles. Every highlight, every memory, in one place.",
          "sized": {
            "title": "Yearly Photo Book {{size}} By Mixtiles",
            "h1": "Yearly Photo Book {{size}}"
          }
        },
        "valentines": {
          "title": "Valentine's Day Photo Book By Mixtiles",
          "h1": "Valentine's Day Photo Book",
          "description": "Celebrate love with a Valentine's Day Photo Book by Mixtiles. Memories sweeter than chocolate.",
          "sized": {
            "title": "Valentine's Day Photo Book {{size}} By Mixtiles",
            "h1": "Valentine's Day Photo Book {{size}}"
          }
        },
        "recipe": {
          "title": "Recipe Photo Book By Mixtiles",
          "h1": "Recipe Photo Book",
          "description": "Savor every delicious moment with a Recipe Photo Book by Mixtiles. Your favorite dishes, forever at your fingertips.",
          "sized": {
            "title": "Recipe Photo Book {{size}} By Mixtiles",
            "h1": "Recipe Photo Book {{size}}"
          }
        },
        "deals": {
          "title": "Photo Book Deals By Mixtiles",
          "h1": "Photo Book Deals",
          "description": "Find amazing photo book deals with Mixtiles. Create beautiful photo books at unbeatable prices and turn your memories into lasting keepsakes.",
          "sized": {
            "title": "Photo Book Deals {{size}} By Mixtiles",
            "h1": "Photo Book Deals {{size}}"
          }
        },
        "designed-covers": {
          "title": "Designed Covers Photo Book By Mixtiles",
          "h1": "Designed Covers Photo Book",
          "description": "Give your photo book a polished finish with a Designed Covers Photo Book by Mixtiles. Choose from beautifully designed covers and turn your memories into a keepsake worth showing off.",
          "sized": {
            "title": "Designed Covers Photo Book {{size}} By Mixtiles",
            "h1": "Designed Covers Photo Book {{size}}"
          }
        },
        "baby": {
          "title": "Baby Photo Books By Mixtiles",
          "h1": "Baby Photo Books",
          "description": "Turn the first year into a Baby Photo Book by Mixtiles. Pick your favourite photos, add a title, and get a book built to survive being read a hundred times.",
          "sized": {
            "title": "Baby Photo Books {{size}} By Mixtiles",
            "h1": "Baby Photo Books {{size}}"
          }
        },
        "wedding-designed-covers": {
          "title": "Wedding Designed Covers Photo Book By Mixtiles",
          "h1": "Wedding Designed Covers Photo Book",
          "description": "Start your wedding book with a cover our designers made for it. Choose a look you love, add your photos, and Mixtiles prints a book worth leaving on the table.",
          "sized": {
            "title": "Wedding Designed Covers Photo Book {{size}} By Mixtiles",
            "h1": "Wedding Designed Covers Photo Book {{size}}"
          }
        },
        "baby-designed-covers": {
          "title": "Baby Designed Covers Photo Book By Mixtiles",
          "h1": "Baby Designed Covers Photo Book",
          "description": "Choose a designed cover made for baby photos and let Mixtiles fill the pages with the first year. No layout work, just pick a cover and add your photos.",
          "sized": {
            "title": "Baby Designed Covers Photo Book {{size}} By Mixtiles",
            "h1": "Baby Designed Covers Photo Book {{size}}"
          }
        },
        "birthday-designed-covers": {
          "title": "Birthday Designed Covers Photo Book By Mixtiles",
          "h1": "Birthday Designed Covers Photo Book",
          "description": "Wrap a year of birthday photos in a cover our designers made for the occasion. Pick a look, add your photos, and Mixtiles turns it into a gift.",
          "sized": {
            "title": "Birthday Designed Covers Photo Book {{size}} By Mixtiles",
            "h1": "Birthday Designed Covers Photo Book {{size}}"
          }
        },
        "coffee-table-designed-covers": {
          "title": "Coffee Table Designed Covers Photo Book By Mixtiles",
          "h1": "Coffee Table Designed Covers Photo Book",
          "description": "A designed cover built for a book that lives out on display. Choose the look, add your best photos, and Mixtiles gives them a finish worth showing off.",
          "sized": {
            "title": "Coffee Table Designed Covers Photo Book {{size}} By Mixtiles",
            "h1": "Coffee Table Designed Covers Photo Book {{size}}"
          }
        },
        "proposal-designed-covers": {
          "title": "Proposal Designed Covers Photo Book By Mixtiles",
          "h1": "Proposal Designed Covers Photo Book",
          "description": "Keep the proposal in a book with a cover our designers made for it. Choose a look, add the photos from the day, and relive the yes whenever you open it.",
          "sized": {
            "title": "Proposal Designed Covers Photo Book {{size}} By Mixtiles",
            "h1": "Proposal Designed Covers Photo Book {{size}}"
          }
        },
        "christmas-designed-covers": {
          "title": "Christmas Designed Covers Photo Book By Mixtiles",
          "h1": "Christmas Designed Covers Photo Book",
          "description": "Give your Christmas photos a festive cover our designers made for the season. Pick a look, add your photos, and get a book you will reopen every year.",
          "sized": {
            "title": "Christmas Designed Covers Photo Book {{size}} By Mixtiles",
            "h1": "Christmas Designed Covers Photo Book {{size}}"
          }
        },
        "family-designed-covers": {
          "title": "Family Designed Covers Photo Book By Mixtiles",
          "h1": "Family Designed Covers Photo Book",
          "description": "Choose a designed cover for your family book and let Mixtiles turn everyday moments into a keepsake worth passing around the table.",
          "sized": {
            "title": "Family Designed Covers Photo Book {{size}} By Mixtiles",
            "h1": "Family Designed Covers Photo Book {{size}}"
          }
        },
        "school-years-designed-covers": {
          "title": "School Years Designed Covers Photo Book By Mixtiles",
          "h1": "School Years Designed Covers Photo Book",
          "description": "Collect the school years in one book with a cover our designers made for it. Pick a look, add the photos, and watch the years fill the pages.",
          "sized": {
            "title": "School Years Designed Covers Photo Book {{size}} By Mixtiles",
            "h1": "School Years Designed Covers Photo Book {{size}}"
          }
        }
      },
      "variant_links": {
        "phototiles_material": "{{frameDisplay}} Photo Tiles"
      }
    }
  }
}
